/** Generate by swagger-axios-codegen */
// @ts-nocheck

/* eslint-disable */
import {
  IRequestConfig,
  IRequestOptions,
  axios,
  getConfigs,
} from './serviceOptions';

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class AdminService {
  /**
   *
   */
  static getAllAdminPrompt(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PromptDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/prompt/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllAdminPrompt(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: PromptAdminUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/prompt/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAdminPromptToken(
    params: {
      /**  */
      type: PromptType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PromptTokenDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/prompt/token';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteAdminCouponById(
    params: {
      /**  */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CouponDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/coupon/{code}';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );
      configs.params = { code: params['code'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllAdminCoupon(
    params: {
      /**  */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CouponDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/coupon/{code}';
      url = url.replace('{code}', params['code'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllAdminCoupon(
    params: {
      /**  */
      code: string;
      /** requestBody */
      body?: CreateAndUpdateCouponAdminRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CouponDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/coupon/{code}';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );
      configs.params = { code: params['code'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAdminCoupon(
    params: {
      /**  */
      size: number;
      /**  */
      code?: string;
      /**  */
      nextToken?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CouponDtoPagedResponseNextPageDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/coupon';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        size: params['size'],
        code: params['code'],
        nextToken: params['nextToken'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAdminCoupon(
    params: {
      /** requestBody */
      body?: CreateAndUpdateCouponAdminRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CouponDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/coupon';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllAdminCompany(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyDetailDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/company/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllAdminCompany(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: CompanyAdminUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/company/{id}';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );
      configs.params = { id: params['id'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAdminCompany(
    params: {
      /**  */
      size: number;
      /**  */
      name?: string;
      /**  */
      nextToken?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompanyBasicDtoPagedResponseNextPageDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/company';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        size: params['size'],
        name: params['name'],
        nextToken: params['nextToken'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllAdminCompanyUsageLimit(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: CompanyUsageLimitUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/admin/company/{id}/usage-limit';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AuthService {
  /**
   *
   */
  static postAuthRefreshToken(
    params: {
      /** requestBody */
      body?: RefreshTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JwtDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/refresh-token';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthSsoVerify(
    params: {
      /** requestBody */
      body?: SsoVerifyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JwtDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/sso/verify';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthSsoStart(
    params: {
      /** requestBody */
      body?: SsoStartRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SsoStartRequestResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/sso/start';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthSamlVerify(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/saml/verify';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthSamlInitiate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/saml/initiate';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthPasswordReset(
    params: {
      /** requestBody */
      body?: ResetPasswordRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/password/reset';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthPasswordForgot(
    params: {
      /** requestBody */
      body?: ForgotRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/password/forgot';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthPasswordChange(
    params: {
      /** requestBody */
      body?: ChangePasswordRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/password/change';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthOtpValidate(
    params: {
      /** requestBody */
      body?: AuthOtpValidationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JwtDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/otp/validate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthOtpRequest(
    params: {
      /** requestBody */
      body?: AuthOtpRequestRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthOtpRequestResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/otp/request';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthMe(options: IRequestOptions = {}): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/me';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAuthMeIdentityNumber(
    params: {
      /** requestBody */
      body?: PutIdentityNumberRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/me/identity-number';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthMeCheck(
    options: IRequestOptions = {}
  ): Promise<AuthCheckResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/me/check';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthLogin(
    params: {
      /** requestBody */
      body?: LoginByEmailRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JwtDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/login';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthExternalOutlook(
    params: {
      /**  */
      redirectUrl?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any | null> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/external/outlook';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { redirectUrl: params['redirectUrl'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthExternalOutlookValidate(
    params: {
      /** requestBody */
      body?: OutlookTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/external/outlook/validate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthExternalOutlookValidateToken(
    params: {
      /** requestBody */
      body?: OutlookAccessTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/external/outlook/validate-token';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuthExternalGoogle(
    params: {
      /**  */
      redirectUrl?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/external/google';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { redirectUrl: params['redirectUrl'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthExternalGoogleValidate(
    params: {
      /** requestBody */
      body?: GoogleTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/external/google/validate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAuthExternalAppleValidate(
    params: {
      /** requestBody */
      body?: AppleTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/auth/external/apple/validate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BoardService {
  /**
   *
   */
  static deleteBoardsById(
    params: {
      /**  */
      boardId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllBoards(
    params: {
      /**  */
      boardId: string;
      /**  */
      candidateQuery?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { candidateQuery: params['candidateQuery'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllBoards(
    params: {
      /**  */
      boardId: string;
      /** requestBody */
      body?: BoardUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoards(
    params: {
      /**  */
      q?: string;
      /**  */
      createdAtFrom?: string;
      /**  */
      createdAtTo?: string;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        createdAtFrom: params['createdAtFrom'],
        createdAtTo: params['createdAtTo'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoards(
    params: {
      /** requestBody */
      body?: BoardRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
 * Handles the PUT request to rearrange a board by reorganizing candidates based on interview data.
This process ensures that candidates are placed into the correct columns according to their interview status,
while maintaining a history of movements within the board.
 */
  static putAllBoardsRearrange(
    params: {
      /**  */
      boardId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}/rearrange';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsInterviews(
    params: {
      /**  */
      size: number;
      /**  */
      q?: string;
      /**  */
      status?: Status[];
      /**  */
      createdBy?: string;
      /**  */
      startDateFrom?: string;
      /**  */
      startDateTo?: string;
      /**  */
      isTemplateInterview?: boolean;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/interviews';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        size: params['size'],
        q: params['q'],
        status: params['status'],
        createdBy: params['createdBy'],
        startDateFrom: params['startDateFrom'],
        startDateTo: params['startDateTo'],
        isTemplateInterview: params['isTemplateInterview'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllBoardsHistory(
    params: {
      /**  */
      boardId: string;
      /**  */
      candidateQuery?: string;
      /**  */
      page?: number;
      /**  */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCandidateLogDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}/history';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        candidateQuery: params['candidateQuery'],
        page: params['page'],
        size: params['size'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllBoardHistoryExcelExport(
    params: {
      /**  */
      boardId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/board/{boardId}/history/excel/export';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllBoardsFunnel(
    params: {
      /**  */
      boardId: string;
      /**  */
      candidateQuery?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FunnelDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}/funnel';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { candidateQuery: params['candidateQuery'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsFunnelInterviewDetailsById(
    params: {
      /**  */
      boardId: string;
      /**  */
      interviewId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FunnelInterviewStatusDetail[]> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/funnel/interview/{interviewId}/details';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{interviewId}', params['interviewId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllBoardsColumnGroups(
    params: {
      /**  */
      boardId: string;
      /** requestBody */
      body?: BoardColumnGroupRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnGroupDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}/column-groups';
      url = url.replace('{boardId}', params['boardId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /** requestBody */
      body?: BoardUpdateColumnGroupRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/{boardId}/column-groups/{columnGroupId}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsColumnGroupsStatusById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnGroupInterviewStatusResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/boards/{boardId}/column-groups/{columnGroupId}/status';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { columnId: params['columnId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteBoardsColumnGroupsColumnById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsColumnGroupsColumnById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnDto> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsColumnById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /** requestBody */
      body?: BoardUpdateColumnRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoardsColumnGroupsColumnById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /** requestBody */
      body?: BoardColumnRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnDto> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/boards/{boardId}/column-groups/{columnGroupId}/column';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsColumnPositionById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /** requestBody */
      body?: BoardColumnPositionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/position';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsColumnCandidatePositionById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /** requestBody */
      body?: BoardCandidateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate-position';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteBoardsColumnGroupsColumnCandidateById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );
      configs.params = { candidateIds: params['candidateIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoardsColumnGroupsColumnCandidateById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /** requestBody */
      body?: BoardAddCandidateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsColumnGroupsColumnCandidateById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateInColumnPositionResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteBoardsColumnGroupsColumnCandidateAdditionalInfoById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
      /**  */
      fieldName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCandidateAdditionalInfoResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/additional-info/{fieldName}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{fieldName}', params['fieldName'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsColumnCandidateAdditionalInfoById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
      /**  */
      fieldName: string;
      /** requestBody */
      body?: BoardCandidateAdditionalInfoUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCandidateAdditionalInfoResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/additional-info/{fieldName}';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{fieldName}', params['fieldName'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsColumnGroupsColumnCandidateAdditionalInfoById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCandidateAdditionalInfoResponse[]> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/additional-info';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoardsColumnGroupsColumnCandidateAdditionalInfoById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: BoardCandidateAdditionalInfoRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCandidateAdditionalInfoResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/additional-info';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsColumnGroupsColumnCandidateCvById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCandidateCv> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/cv';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsColumnCandidateCvById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: BoardCandidateCvRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/cv';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsColumnCandidateCvScoreById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: BoardCandidateCvScoreRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/cv/score';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBoardsColumnGroupsColumnCandidateCvFileStatusById(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCvExtractionQueueResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/cv/file/{requestId}/status';
      url = url.replace('{requestId}', params['requestId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoardsColumnGroupsColumnCandidateCvFileById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /** requestBody */
      body?: BoardCandidateCvFileRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/cv/file';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoardsColumnGroupsColumnCandidateCvAnalyzeById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /**  */
      columnId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/column/{columnId}/candidate/{candidateId}/cv/analyze';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');
      url = url.replace('{columnId}', params['columnId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllBoardsCandidateCvAnalyzeStatus(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoardCvAiAnalyzeQueueResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/boards/candidate/cv/analyze/{requestId}/status';
      url = url.replace('{requestId}', params['requestId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteBoardsColumnGroupsCategorizeCandidatesDeleteById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /** requestBody */
      body?: CategorizeInterviewCandidatesDeleteRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/categorize-candidates/delete';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn(
        '适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body'
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postBoardsColumnGroupsCategorizeCandidatesById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /** requestBody */
      body?: CategorizeInterviewCandidatesRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/categorize-candidates';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putBoardsColumnGroupsCategorizeCandidatesById(
    params: {
      /**  */
      boardId: string;
      /**  */
      columnGroupId: string;
      /** requestBody */
      body?: UpdateCategorizeInterviewCandidatesRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/boards/{boardId}/column-groups/{columnGroupId}/categorize-candidates';
      url = url.replace('{boardId}', params['boardId'] + '');
      url = url.replace('{columnGroupId}', params['columnGroupId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CandidateService {
  /**
   *
   */
  static getAllCandidates(
    params: {
      /**  */
      candidateId: string;
      /**  */
      securityToken: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidatePublicDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates/{candidateId}';
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { securityToken: params['securityToken'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCandidates(
    params: {
      /**  */
      interviewsId?: string;
      /**  */
      q?: string;
      /**  */
      fullName?: string;
      /**  */
      ratings?: any | null[];
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
      /**  */
      status?: InterviewStatus[];
      /**  */
      sortColumn?: CandidateSortColumn;
      /**  */
      sortOrder?: CustomSortOrder;
      /**  */
      candidateListType?: CandidateListType;
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      cvScoreFrom?: number;
      /**  */
      cvScoreTo?: number;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        interviewsId: params['interviewsId'],
        q: params['q'],
        fullName: params['fullName'],
        ratings: params['ratings'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
        status: params['status'],
        sortColumn: params['sortColumn'],
        sortOrder: params['sortOrder'],
        candidateListType: params['candidateListType'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        cvScoreFrom: params['cvScoreFrom'],
        cvScoreTo: params['cvScoreTo'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
 * Each request will return the last none-answered question
After answering the question, you will be able to get the next one
 */
  static getAllCandidatesQuestions(
    params: {
      /**  */
      candidateId: string;
      /**  */
      securityCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewQuestionResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates/{candidateId}/questions';
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { securityCode: params['securityCode'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCandidatesApplyPenaltyTabChange(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates/apply-penalty/tab-change';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postCandidatesApplyPenaltyRefresh(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates/apply-penalty/refresh';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllCandidatesFeedback(
    params: {
      /**  */
      candidateId: string;
      /** requestBody */
      body?: PutCandidateFeedbackHistoryRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates/{candidateId}/feedback';
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCandidatesExcelExport(
    params: {
      /**  */
      interviewsId?: string;
      /**  */
      q?: string;
      /**  */
      ratings?: any | null[];
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      status?: InterviewStatus[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidates/excel/export';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        interviewsId: params['interviewsId'],
        q: params['q'],
        ratings: params['ratings'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        status: params['status'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCandidatesQuestionsEarlyFinishById(
    params: {
      /**  */
      questionId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/candidates/{candidateId}/questions/{questionId}/early-finish';
      url = url.replace('{questionId}', params['questionId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCandidatesQuestionsAnswerById(
    params: {
      /**  */
      questionId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: AnswerQuestionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/candidates/{candidateId}/questions/{questionId}/answer';
      url = url.replace('{questionId}', params['questionId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CandidateProfileService {
  /**
   *
   */
  static deleteCandidateProfile(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCandidateProfile(
    params: {
      /** requestBody */
      body?: CandidateProfileRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCandidateProfileMe(
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile/me';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteCandidateProfileProfileImage(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile/profile-image';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCandidateProfileProfileImage(
    params: {
      /** requestBody */
      body?: CandidateProfileImageRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile/profile-image';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postCandidateProfileExternalLoginAppleValidate(
    params: {
      /** requestBody */
      body?: AppleTokenRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JwtDto> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/candidate-profile/external/login/apple/validate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCandidateProfileCv(
    options: IRequestOptions = {}
  ): Promise<CvResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile/cv';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCandidateProfileCv(
    params: {
      /** requestBody */
      body?: CvUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/candidate-profile/cv';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CompanyService {
  /**
   *
   */
  static getCompanyInfo(
    options: IRequestOptions = {}
  ): Promise<CompanyDetailDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/info';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompany(
    params: {
      /** requestBody */
      body?: CompanyUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteCompanyUserById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyUser(
    options: IRequestOptions = {}
  ): Promise<UserBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postCompanyUser(
    params: {
      /** requestBody */
      body?: UserRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompanyUser(
    params: {
      /** requestBody */
      body?: UserPutRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompanyUserRole(
    params: {
      /** requestBody */
      body?: UserRoleRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user/role';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllCompanyUserResend(
    params: {
      /**  */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user/{userId}/resend';
      url = url.replace('{userId}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompanyUserPosition(
    params: {
      /** requestBody */
      body?: UserPositionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user/position';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteCompanyLogo(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/logo';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyLogo(
    options: IRequestOptions = {}
  ): Promise<CompanyLogoUrlResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/logo';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompanyLogo(
    params: {
      /** requestBody */
      body?: CompanyLogoRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/logo';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompanyUserDepartment(
    params: {
      /** requestBody */
      body?: UserDepartmentRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user/department';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllCompanyUserCreatedInterviews(
    params: {
      /**  */
      userId: string;
      /**  */
      q?: string;
      /**  */
      page?: number;
      /**  */
      size?: number;
      /**  */
      startDateFrom?: string;
      /**  */
      startDateTo?: string;
      /**  */
      isTemplateInterview?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/user/{userId}/created-interviews';
      url = url.replace('{userId}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        page: params['page'],
        size: params['size'],
        startDateFrom: params['startDateFrom'],
        startDateTo: params['startDateTo'],
        isTemplateInterview: params['isTemplateInterview'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyUsageLimit(
    options: IRequestOptions = {}
  ): Promise<CompanyUsageLimitDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/usage-limit';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanySmtp(
    options: IRequestOptions = {}
  ): Promise<CompanySmtpSettingsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/smtp';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putCompanySmtp(
    params: {
      /** requestBody */
      body?: CompanySmtpSettingsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/smtp';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postCompanySmtpTest(
    params: {
      /** requestBody */
      body?: TestRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/smtp/test';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllCompanyInterviewShare(
    params: {
      /**  */
      interviewId: string;
      /** requestBody */
      body?: CompanyShareRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/interview/{interviewId}/share';
      url = url.replace('{interviewId}', params['interviewId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ConfirmService {
  /**
   *
   */
  static postPaymentStoreConfirm(
    params: {
      /** requestBody */
      body?: ConfirmPaymentRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/payment/store/confirm';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CvAnalysisService {
  /**
   *
   */
  static getAllCvAnalysis(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CvAnalysisResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCvAnalysis(
    params: {
      /**  */
      q?: string;
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CvAnalysisBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postCvAnalysisStart(
    params: {
      /** requestBody */
      body?: StartCvAnalysisRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/start';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllCvAnalysisReport(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CvAnalysisPublicDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/{id}/report';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllCvAnalysisPublic(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CvAnalysisPublicDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/{id}/public';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postCvAnalysisSectionPossibleById(
    params: {
      /**  */
      id: string;
      /**  */
      section: CvSection;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/{id}/section/{section}/possible';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{section}', params['section'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllCvAnalysisSectionPossibleStatus(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CvSectionPossibleImprovementsQueueResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/cv-analysis/section/possible/status/{requestId}';
      url = url.replace('{requestId}', params['requestId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCvAnalysisPaymentInit(
    params: {
      /**  */
      email: string;
      /**  */
      successfulCallbackUrl: string;
      /**  */
      failedCallbackUrl: string;
      /**  */
      productId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentInitResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/payment/init';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        email: params['email'],
        successfulCallbackUrl: params['successfulCallbackUrl'],
        failedCallbackUrl: params['failedCallbackUrl'],
        productId: params['productId'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllCvAnalysisFeedbackLike(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
      /** requestBody */
      body?: LikeRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/{id}/feedback/like';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllCvAnalysisFeedbackDislike(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
      /** requestBody */
      body?: DislikeRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/cv-analysis/{id}/feedback/dislike';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DashboardService {
  /**
   *
   */
  static getDashboardSummary(
    options: IRequestOptions = {}
  ): Promise<SummaryResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/dashboard/summary';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDashboardInterviewDaily(
    params: {
      /**  */
      date?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DailyInterviewsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/dashboard/interview/daily';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { date: params['date'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDashboardInterviewLast(
    options: IRequestOptions = {}
  ): Promise<LastInterviewResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/dashboard/interview/last';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDashboardCandidatesLast(
    params: {
      /**  */
      q?: string;
      /**  */
      ratings?: any | null[];
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
      /**  */
      status?: InterviewStatus[];
      /**  */
      sortColumn?: CandidateSortColumn;
      /**  */
      sortOrder?: CustomSortOrder;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LastCompletedCandidateResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/dashboard/candidates/last';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        ratings: params['ratings'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
        status: params['status'],
        sortColumn: params['sortColumn'],
        sortOrder: params['sortOrder'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
}

export class EmailService {
  /**
   *
   */
  static deleteEmailTemplateById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/email/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllEmailTemplate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MailTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/email/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllEmailTemplate(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: UpdateMailTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/email/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEmailTemplate(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MailTemplateDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/email/template';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postEmailTemplate(
    params: {
      /** requestBody */
      body?: MailTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/email/template';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEmailTemplateToken(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TemplateTokenDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/email/template/token';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
}

export class FileService {
  /**
   *
   */
  static postFilesAccess(
    params: {
      /** requestBody */
      body?: UploadFileRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UploadFileResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/files/access';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class HeyGenService {
  /**
   *
   */
  static postHeygenWebhook(
    params: {
      /** requestBody */
      body?: HeyGenWebhookRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/heygen/webhook';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class IntegrationService {
  /**
   *
   */
  static getIntegrationInterviews(
    params: {
      /**  */
      size: number;
      /**  */
      q?: string;
      /**  */
      status?: Status[];
      /**  */
      createdBy?: string;
      /**  */
      startDateFrom?: string;
      /**  */
      startDateTo?: string;
      /**  */
      isTemplateInterview?: boolean;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/integration/interviews';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        size: params['size'],
        q: params['q'],
        status: params['status'],
        createdBy: params['createdBy'],
        startDateFrom: params['startDateFrom'],
        startDateTo: params['startDateTo'],
        isTemplateInterview: params['isTemplateInterview'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getIntegrationInterviewsCandidatesById(
    params: {
      /**  */
      id: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IntegrationCandidateDetailResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/integration/interviews/{id}/candidates/{candidateId}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllIntegrationInterviewsCandidates(
    params: {
      /**  */
      id: string;
      /**  */
      q?: string;
      /**  */
      ratings?: any | null[];
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
      /**  */
      status?: InterviewStatus[];
      /**  */
      sortColumn?: CandidateSortColumn;
      /**  */
      sortOrder?: CustomSortOrder;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/integration/interviews/{id}/candidates';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        ratings: params['ratings'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
        status: params['status'],
        sortColumn: params['sortColumn'],
        sortOrder: params['sortOrder'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllIntegrationInterviewsCandidates(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: IntegrationInviteCandidateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/integration/interviews/{id}/candidates';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class InterviewService {
  /**
   *
   */
  static deleteInterviewsById(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviews(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewDetailResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviews(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: UpdateInterviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviews(
    params: {
      /**  */
      size: number;
      /**  */
      q?: string;
      /**  */
      status?: Status[];
      /**  */
      createdBy?: string;
      /**  */
      startDateFrom?: string;
      /**  */
      startDateTo?: string;
      /**  */
      isTemplateInterview?: boolean;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        size: params['size'],
        q: params['q'],
        status: params['status'],
        createdBy: params['createdBy'],
        startDateFrom: params['startDateFrom'],
        startDateTo: params['startDateTo'],
        isTemplateInterview: params['isTemplateInterview'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviews(
    params: {
      /** requestBody */
      body?: InterviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewWaiting(
    options: IRequestOptions = {}
  ): Promise<WaitingInterviewBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/waiting';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllInterviewWaitingStart(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: StartWaitingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{id}/waiting/start';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsTags(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateTagResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/tags';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { requestId: params['requestId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewsTags(
    params: {
      /** requestBody */
      body?: CreateTagRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/tags';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewsStatus(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: UpdateInterviewStatusRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/status';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewSkill(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/skill';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewSkill(
    params: {
      /** requestBody */
      body?: SkillRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/skill';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteApiInterviewCandidateShareEmailById(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
      /**  */
      shareId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/api/v1/interview/{id}/candidate/{candidateId}/share/{shareId}/email/{email}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{email}', params['email'] + '');
      url = url.replace('{shareId}', params['shareId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllApiInterviewShare(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SharedInterviewDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/interview/{id}/share';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteApiInterviewShareCandidateById(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/interview/{id}/share/{email}/candidate';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{email}', params['email'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn(
        '适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body'
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getApiInterviewShareCandidateById(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/interview/{id}/share/{email}/candidate';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{email}', params['email'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewsReport(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      completedAtFrom?: string;
      /**  */
      completedAtTo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/report';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        completedAtFrom: params['completedAtFrom'],
        completedAtTo: params['completedAtTo'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewsReportQuestionsSummaryById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      questionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/report/questions/{questionId}/summary';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsReportById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      reportId: string;
      /**  */
      completedAtFrom?: string;
      /**  */
      completedAtTo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/report/{reportId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{reportId}', params['reportId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        completedAtFrom: params['completedAtFrom'],
        completedAtTo: params['completedAtTo'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllInterviewsReportShare(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/report/share';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewsReportExcel(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/report/excel';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewsReplicate(
    params: {
      /** requestBody */
      body?: InterviewReplicateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/replicate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewReminder(
    params: {
      /**  */
      reminderId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any | null> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/reminder/{reminderId}';
      url = url.replace('{reminderId}', params['reminderId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewReminders(
    params: {
      /**  */
      remindDateFrom?: string;
      /**  */
      remindDateTo?: string;
      /**  */
      interviewId?: string;
      /**  */
      candidateId?: string;
      /**  */
      isManual?: boolean;
      /**  */
      isSent?: boolean;
      /**  */
      page?: number;
      /**  */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReminderGroupDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/reminders';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        remindDateFrom: params['remindDateFrom'],
        remindDateTo: params['remindDateTo'],
        interviewId: params['interviewId'],
        candidateId: params['candidateId'],
        isManual: params['isManual'],
        isSent: params['isSent'],
        page: params['page'],
        size: params['size'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewQuestions(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewQuestionsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{id}/questions';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewQuestions(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: UpdateInterviewQuestionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{id}/questions';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsQuestionsAi(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AIQuestionGenerationResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/questions/ai';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { requestId: params['requestId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewsQuestionsAi(
    params: {
      /** requestBody */
      body?: AiQuestionsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/questions/ai';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsCompanyInfoById(
    params: {
      /**  */
      interviewId: string;
      /**  */
      companyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PublicInterviewInfo> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interviews/{interviewId}/company/{companyId}/info';
      url = url.replace('{interviewId}', params['interviewId'] + '');
      url = url.replace('{companyId}', params['companyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewOtpValidate(
    params: {
      /** requestBody */
      body?: OtpValidationResult;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/otp/validate';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewOtpRequest(
    params: {
      /** requestBody */
      body?: OtpRequestRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/otp/request';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewJobDescription(
    params: {
      /**  */
      interviewId: string;
      /** requestBody */
      body?: UpdateJobDescriptionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{interviewId}/job-description';
      url = url.replace('{interviewId}', params['interviewId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewsInterviewTemplates(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/interviewTemplates';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewsSettings(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: UpdateInterviewSettings;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/settings/{interviewsId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteInterviewInstructionVideoById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{id}/instruction-video';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewInstructionVideo(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: InstructionVideoRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{id}/instruction-video';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewInformationalText(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: InformationalTextRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{id}/informational-text';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewCompleted(
    options: IRequestOptions = {}
  ): Promise<CompletedInterviewBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/completed';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewsInvitationSetting(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InvitationSettingResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/invitation-setting';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewsInvitationSetting(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: InvitationSettingRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/invitation-setting';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteInterviewsCandidatesBatchDelete(
    params: {
      /** requestBody */
      body?: DeleteCandidatesFromMultipleInterviewsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/candidates/batch-delete';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn(
        '适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body'
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteInterviewsCandidatesById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/candidates';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );
      configs.params = { candidateIds: params['candidateIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewsCandidates(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      q?: string;
      /**  */
      ratings?: any | null[];
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      cvScoreFrom?: number;
      /**  */
      cvScoreTo?: number;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
      /**  */
      status?: InterviewStatus[];
      /**  */
      sortColumn?: CandidateSortColumn;
      /**  */
      sortOrder?: CustomSortOrder;
      /**  */
      candidateListType?: CandidateListType;
      /**  */
      identityNumber?: string;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/candidates';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        ratings: params['ratings'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        cvScoreFrom: params['cvScoreFrom'],
        cvScoreTo: params['cvScoreTo'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
        status: params['status'],
        sortColumn: params['sortColumn'],
        sortOrder: params['sortOrder'],
        candidateListType: params['candidateListType'],
        identityNumber: params['identityNumber'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsCandidatesById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateDetailResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interviews/{interviewsId}/candidates/{candidateId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: PutCandidateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interviews/{interviewsId}/candidates/{candidateId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsCandidatesSuggestionsById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SuggestionResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/suggestions';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewsQuestionAnswerPossibleById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      questionId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/question/{questionId}/answer/possible';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { candidateId: params['candidateId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsQuestionAnswerPossibleStatusById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      questionId: string;
      /**  */
      requestId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionPossibleAnswerResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/question/{questionId}/answer/possible/status';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        requestId: params['requestId'],
        candidateId: params['candidateId'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesStatusById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: PutCandidateStatusRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/status';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewCandidateStatusPositiveById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interview/{interviewsId}/candidate/{candidateId}/status/positive';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewCandidateStatusNegativeById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interview/{interviewsId}/candidate/{candidateId}/status/negative';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllInterviewsCandidatesShare(
    params: {
      /**  */
      interviewId: string;
      /** requestBody */
      body?: ShareCandidatesRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewId}/candidates/share';
      url = url.replace('{interviewId}', params['interviewId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewsCandidatesReInterviewById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: ReInterviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/re-interview';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesQuestionsReanalyzeById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      questionId: string;
      /**  */
      candidateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/questions/{questionId}/reanalyze';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesRateById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: RateCandidateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/rate';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesQuestionsNoteById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /**  */
      questionId: string;
      /** requestBody */
      body?: PutQuestionNoteRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/questions/{questionId}/note';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesQuestionsAiScoreById(
    params: {
      /**  */
      interviewId: string;
      /**  */
      candidateId: string;
      /**  */
      questionId: string;
      /** requestBody */
      body?: AiScorePutRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewId}/candidates/{candidateId}/questions/{questionId}/ai-score';
      url = url.replace('{interviewId}', params['interviewId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesListTypeById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: PutCandidateListTypeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/list-type';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllApiInterviewCandidateList(
    params: {
      /**  */
      id: string;
      /**  */
      candidateIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/interview/{id}/candidate/list';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { candidateIds: params['candidateIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewsCandidatesAdd(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: InviteCandidateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/candidates/add';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Invites candidates to an interview via multiple channels.
   */
  static putAllInterviewsCandidatesInvite(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: InviteCandidateViaMailRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InviteCandidateResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/{interviewsId}/candidates/invite';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Invites All candidates via multiple channels.
   */
  static putInterviewsAll(
    params: {
      /** requestBody */
      body?: InviteAllCandidatesViaMailRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InviteCandidateResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interviews/all';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesFeedbackById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /** requestBody */
      body?: PutCandidateFeedbackRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/feedback';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllInterviewCandidateExcel(
    params: {
      /**  */
      interviewId: string;
      /** requestBody */
      body?: ExcelImportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExcelImportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview/{interviewId}/candidate/excel';
      url = url.replace('{interviewId}', params['interviewId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewsCandidatesExcelExport(
    params: {
      /**  */
      interviewId: string;
      /**  */
      q?: string;
      /**  */
      ratings?: any | null[];
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
      /**  */
      status?: InterviewStatus[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interviews/{interviewId}/candidates/excel/export';
      url = url.replace('{interviewId}', params['interviewId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        ratings: params['ratings'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
        status: params['status'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewsCandidatesQuestionEmotionsById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /**  */
      questionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmotionResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/question/{questionId}/emotions';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCompanyAttendById(
    params: {
      /**  */
      interviewId: string;
      /**  */
      companyId: string;
      /** requestBody */
      body?: CandidateAttendRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interviews/{interviewId}/company/{companyId}/attend';
      url = url.replace('{interviewId}', params['interviewId'] + '');
      url = url.replace('{companyId}', params['companyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesById1(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /**  */
      questionId: string;
      /** requestBody */
      body?: AnswerQuestionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/{questionId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putInterviewsCandidatesQuestionSupportEditById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      candidateId: string;
      /**  */
      questionId: string;
      /** requestBody */
      body?: SupportAccountAnswerEdit;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interviews/{interviewsId}/candidates/{candidateId}/question/{questionId}/support-edit';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{candidateId}', params['candidateId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCompanyShares(
    params: {
      /**  */
      sharedCandidateEmail?: string;
      /**  */
      sharedCandidateFullName?: string;
      /**  */
      sharedCandidateId?: string;
      /**  */
      sharedInterviewId?: string;
      /**  */
      sharedInterviewTitle?: string;
      /**  */
      sharedPersonEmail?: string;
      /**  */
      sharedPersonFullName?: string;
      /**  */
      sharingPersonFullName?: string;
      /**  */
      query?: string;
      /**  */
      isSystemUser?: boolean;
      /**  */
      expirationDateFrom?: string;
      /**  */
      expirationDateTo?: string;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShareIndexModelPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/company/shares';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        sharedCandidateEmail: params['sharedCandidateEmail'],
        sharedCandidateFullName: params['sharedCandidateFullName'],
        sharedCandidateId: params['sharedCandidateId'],
        sharedInterviewId: params['sharedInterviewId'],
        sharedInterviewTitle: params['sharedInterviewTitle'],
        sharedPersonEmail: params['sharedPersonEmail'],
        sharedPersonFullName: params['sharedPersonFullName'],
        sharingPersonFullName: params['sharingPersonFullName'],
        query: params['query'],
        isSystemUser: params['isSystemUser'],
        expirationDateFrom: params['expirationDateFrom'],
        expirationDateTo: params['expirationDateTo'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
}

export class InterviewShareService {
  /**
   *
   */
  static getApiInterviewShare(
    params: {
      /**  */
      q?: string;
      /**  */
      remainingDayStart?: number;
      /**  */
      remainingDayEnd?: number;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SharedInterviewDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/interview/share';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        remainingDayStart: params['remainingDayStart'],
        remainingDayEnd: params['remainingDayEnd'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
}

export class InterviewTemplateService {
  /**
   *
   */
  static deleteInterviewTemplateById(
    params: {
      /**  */
      interviewTemplateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview-template/{interviewTemplateId}';
      url = url.replace(
        '{interviewTemplateId}',
        params['interviewTemplateId'] + ''
      );

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewTemplate(
    params: {
      /**  */
      interviewTemplateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewTemplateDetailResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview-template/{interviewTemplateId}';
      url = url.replace(
        '{interviewTemplateId}',
        params['interviewTemplateId'] + ''
      );

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewTemplate(
    params: {
      /**  */
      size: number;
      /**  */
      q?: string;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewTemplateBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview-template';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        size: params['size'],
        q: params['q'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postInterviewTemplate(
    params: {
      /** requestBody */
      body?: InterviewTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview-template';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllInterviewTemplateQuestions(
    params: {
      /**  */
      interviewTemplateId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InterviewQuestionsResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interview-template/{interviewTemplateId}/questions';
      url = url.replace(
        '{interviewTemplateId}',
        params['interviewTemplateId'] + ''
      );

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllInterviewTemplateQuestions(
    params: {
      /**  */
      interviewTemplateId: string;
      /** requestBody */
      body?: UpdateInterviewQuestionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/interview-template/{interviewTemplateId}/questions';
      url = url.replace(
        '{interviewTemplateId}',
        params['interviewTemplateId'] + ''
      );

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllInterviewTemplateCreateInterview(
    params: {
      /**  */
      interviewTemplateId: string;
      /** requestBody */
      body?: TemplateCreateInterviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/interview-template/{interviewTemplateId}/create-interview';
      url = url.replace(
        '{interviewTemplateId}',
        params['interviewTemplateId'] + ''
      );

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInterviewTemplateCompanyList(
    options: IRequestOptions = {}
  ): Promise<CompanyBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/interview-template/company-list';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class MediaService {
  /**
   *
   */
  static postMediaAccess(
    params: {
      /** requestBody */
      body?: AccessRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UploadUrlPostResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/media/access';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class OdiBotService {
  /**
   *
   */
  static postOdiBotStop(
    params: {
      /** requestBody */
      body?: OdiStartRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/odi-bot/stop';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postOdiBotStart(
    params: {
      /** requestBody */
      body?: OdiStartRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/odi-bot/start';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PhoneCallService {
  /**
   *
   */
  static deletePhoneCallTemplateById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/phone-call/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllPhoneCallTemplate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PhoneCallTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/phone-call/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllPhoneCallTemplate(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: UpdatePhoneCallTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/phone-call/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPhoneCallTemplate(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PhoneCallTemplateDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/phone-call/template';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postPhoneCallTemplate(
    params: {
      /** requestBody */
      body?: PhoneCallTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/phone-call/template';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPhoneCallTemplateToken(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TemplateTokenDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/phone-call/template/token';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
}

export class PingService {
  /**
   *
   */
  static getPing(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ping';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class PubSubService {
  /**
   *
   */
  static postPubSub(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/pub-sub';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postStatsPubSub(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/stats/pub-sub';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
}

export class ReportService {
  /**
   *
   */
  static getReportAtsExcelExport(
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/report/ats/excel/export';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getReportAtsCandidateCountByStatus(
    params: {
      /**  */
      createdAtFrom?: string;
      /**  */
      createdAtTo?: string;
      /**  */
      boardId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/report/ats/candidate-count-by-status';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        createdAtFrom: params['createdAtFrom'],
        createdAtTo: params['createdAtTo'],
        boardId: params['boardId'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getReportAtsCandidateDistributionByDate(
    params: {
      /**  */
      createdAtFrom?: string;
      /**  */
      createdAtTo?: string;
      /**  */
      boardId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/report/ats/candidate-distribution-by-date';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        createdAtFrom: params['createdAtFrom'],
        createdAtTo: params['createdAtTo'],
        boardId: params['boardId'],
      };

      axios(configs, resolve, reject);
    });
  }
}

export class SmsService {
  /**
   *
   */
  static deleteSmsTemplateById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/sms/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSmsTemplate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SmsTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/sms/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllSmsTemplate(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: UpdateSmsTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/sms/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSmsTemplate(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SmsTemplateDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/sms/template';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postSmsTemplate(
    params: {
      /** requestBody */
      body?: SmsTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/sms/template';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSmsTemplateToken(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TemplateTokenDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/sms/template/token';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
}

export class SurveyService {
  /**
   *
   */
  static deleteSurveysById(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveys(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllSurveys(
    params: {
      /**  */
      surveyId: string;
      /** requestBody */
      body?: UpdateSurveyTitleRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSurveys(
    params: {
      /**  */
      q?: string;
      /**  */
      startDateFrom?: string;
      /**  */
      startDateTo?: string;
      /**  */
      endDateFrom?: string;
      /**  */
      endDateTo?: string;
      /**  */
      createdAtFrom?: string;
      /**  */
      createdAtTo?: string;
      /**  */
      questionCountFrom?: number;
      /**  */
      questionCountTo?: number;
      /**  */
      status?: SurveyStatus[];
      /**  */
      createdBy?: string;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        startDateFrom: params['startDateFrom'],
        startDateTo: params['startDateTo'],
        endDateFrom: params['endDateFrom'],
        endDateTo: params['endDateTo'],
        createdAtFrom: params['createdAtFrom'],
        createdAtTo: params['createdAtTo'],
        questionCountFrom: params['questionCountFrom'],
        questionCountTo: params['questionCountTo'],
        status: params['status'],
        createdBy: params['createdBy'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postSurveys(
    params: {
      /** requestBody */
      body?: SurveyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteSurveysParticipantsById(
    params: {
      /**  */
      surveyId: string;
      /**  */
      participationIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/participants';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );
      configs.params = { participationIds: params['participationIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysParticipants(
    params: {
      /**  */
      surveyId: string;
      /**  */
      q?: string;
      /**  */
      status?: SurveyParticipationStatus[];
      /**  */
      createdAtFrom?: string;
      /**  */
      createdAtTo?: string;
      /**  */
      completedAtFrom?: string;
      /**  */
      completedAtTo?: string;
      /**  */
      sortColumn?: SurveyParticipationSortColumn;
      /**  */
      sortOrder?: CustomSortOrder;
      /**  */
      size?: number;
      /**  */
      page?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyParticipationBasicDtoPagedResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/participants';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        status: params['status'],
        createdAtFrom: params['createdAtFrom'],
        createdAtTo: params['createdAtTo'],
        completedAtFrom: params['completedAtFrom'],
        completedAtTo: params['completedAtTo'],
        sortColumn: params['sortColumn'],
        sortOrder: params['sortOrder'],
        size: params['size'],
        page: params['page'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllSurveysParticipantsReinvite(
    params: {
      /**  */
      surveyId: string;
      /** requestBody */
      body?: ReinviteSurveyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/participants/reinvite';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllSurveysInvite(
    params: {
      /**  */
      surveyId: string;
      /** requestBody */
      body?: InviteSurveyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/invite';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllSurveysInviteExcel(
    params: {
      /**  */
      surveyId: string;
      /** requestBody */
      body?: SurveyParticipationExcelImportRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExcelImportResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/invite/excel';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysReportsSummary(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/reports/summary';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysReportsAiReview(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyAiReviewReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/reports/ai-review';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysReportsHeatmap(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyHeatmapDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/reports/heatmap';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysReportsDimensionQuestionDetail(
    params: {
      /**  */
      surveyId: string;
      /**  */
      dimension?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DimensionQuestionDetailReportDto> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/surveys/{surveyId}/reports/dimension-question-detail';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { dimension: params['dimension'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysQuestions(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyQuestionResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/questions';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllSurveysQuestions(
    params: {
      /**  */
      surveyId: string;
      /** requestBody */
      body?: UpdateSurveyQuestionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/questions';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysDimensions(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyDimensionsDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/dimensions';
      url = url.replace('{surveyId}', params['surveyId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveysReportsDimension(
    params: {
      /**  */
      surveyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DimensionReportDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/surveys/{surveyId}/reports/dimension';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { surveyId: params['surveyId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class SurveyParticipationService {
  /**
   *
   */
  static getAllSurveyParticipationsSurvey(
    params: {
      /**  */
      participationId: string;
      /**  */
      surveyId: string;
      /**  */
      companyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipationSurveyDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/survey-participations/{participationId}/survey';
      url = url.replace('{participationId}', params['participationId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        surveyId: params['surveyId'],
        companyId: params['companyId'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllSurveyParticipationsQuestions(
    params: {
      /**  */
      participationId: string;
      /**  */
      surveyId: string;
      /**  */
      companyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SurveyParticipationQuestionResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/survey-participations/{participationId}/questions';
      url = url.replace('{participationId}', params['participationId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        surveyId: params['surveyId'],
        companyId: params['companyId'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllSurveyParticipationsAnswers(
    params: {
      /**  */
      participationId: string;
      /**  */
      surveyId: string;
      /**  */
      companyId: string;
      /** requestBody */
      body?: SurveyAnswerQuestionsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/survey-participations/{participationId}/answers';
      url = url.replace('{participationId}', params['participationId'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );
      configs.params = {
        surveyId: params['surveyId'],
        companyId: params['companyId'],
      };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TrainingService {
  /**
   * Version 2 endpoint to create a training interview for a coach using an existing question ID.
   */
  static postV2TrainingInterview(
    params: {
      /** requestBody */
      body?: TrainingInterviewCreateWithQuestionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateTrainingInterviewResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v2/training/interview';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Version 2 endpoint to Check the status of a training interview question
   */
  static getV2TrainingInterviewStatus(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrainingInterviewQuestionsCreationResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v2/training/interview/status';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { requestId: params['requestId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create a question for a training interview
   */
  static postV2TrainingInterviewQuestions(
    params: {
      /** requestBody */
      body?: TrainingInterviewCreateQuestionsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v2/training/interview/questions';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTrainingPaymentInit(
    params: {
      /**  */
      email: string;
      /**  */
      successfulCallbackUrl: string;
      /**  */
      failedCallbackUrl: string;
      /**  */
      productId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentInitResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/payment/init';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        email: params['email'],
        successfulCallbackUrl: params['successfulCallbackUrl'],
        failedCallbackUrl: params['failedCallbackUrl'],
        productId: params['productId'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllTrainingInterview(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrainingCandidateDetailResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview/{interviewsId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static patchAllTrainingInterview(
    params: {
      /**  */
      interviewsId: string;
      /** requestBody */
      body?: TrainingReminderRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview/{interviewsId}';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        url,
        options
      );

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn(
        '适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body'
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTrainingInterview(
    params: {
      /**  */
      q?: string;
      /**  */
      aiScoreFrom?: number;
      /**  */
      aiScoreTo?: number;
      /**  */
      dateFrom?: string;
      /**  */
      dateTo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CandidateBasicDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        q: params['q'],
        aiScoreFrom: params['aiScoreFrom'],
        aiScoreTo: params['aiScoreTo'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postTrainingInterview(
    params: {
      /** requestBody */
      body?: TrainingInterviewCreateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTrainingInterviewStatus(
    params: {
      /**  */
      requestId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrainingInterviewCreationResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview/status';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { requestId: params['requestId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllTrainingInterviewQuestionRetry(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/v1/training/interview/{interviewsId}/question/retry';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postTrainingInterviewQuestionAnswerPossibleById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      questionId: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/training/interview/{interviewsId}/question/{questionId}/answer/possible';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTrainingInterviewQuestionAnswerPossibleStatusById(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      questionId: string;
      /**  */
      requestId: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionPossibleAnswerQueueResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath +
        '/v1/training/interview/{interviewsId}/question/{questionId}/answer/possible/status';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');
      url = url.replace('{questionId}', params['questionId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = {
        requestId: params['requestId'],
        email: params['email'],
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllTrainingInterviewPublic(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrainingCandidatePublicDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview/{interviewsId}/public';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllTrainingInterviewLink(
    params: {
      /**  */
      interviewsId: string;
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview/{interviewsId}/link';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllTrainingInterviewInfo(
    params: {
      /**  */
      interviewsId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrainingCandidateInterviewInfoResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/interview/{interviewsId}/info';
      url = url.replace('{interviewsId}', params['interviewsId'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllTrainingFeedbackLike(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
      /** requestBody */
      body?: CoachLikeRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/{id}/feedback/like';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postAllTrainingFeedbackDislike(
    params: {
      /**  */
      id: string;
      /**  */
      email: string;
      /** requestBody */
      body?: CoachDislikeRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/training/{id}/feedback/dislike';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UserService {
  /**
   *
   */
  static putUser(
    params: {
      /** requestBody */
      body?: UserUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/user';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteApiUserCoupon(
    params: {
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/user/coupon';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getApiUserCoupon(
    params: {
      /**  */
      email: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetCouponCodeResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/user/coupon';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postApiUserCoupon(
    params: {
      /**  */
      email: string;
      /** requestBody */
      body?: ApplyCouponRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplyCouponResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/user/coupon';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );
      configs.params = { email: params['email'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class WhatsappService {
  /**
   *
   */
  static deleteWhatsappTemplateById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/whatsapp/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllWhatsappTemplate(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WhatsappTemplateDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/whatsapp/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static putAllWhatsappTemplate(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: UpdateWhatsappTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/whatsapp/template/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getWhatsappTemplate(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WhatsappTemplateDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/whatsapp/template';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postWhatsappTemplate(
    params: {
      /** requestBody */
      body?: WhatsappTemplateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/whatsapp/template';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options
      );

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getWhatsappTemplateToken(
    params: {
      /**  */
      type?: TemplateType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TemplateTokenDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/whatsapp/template/token';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options
      );
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
}

export interface AIQuestionGenerationResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  data?: AiQuestionModel[];
}

export interface AccessRequest {
  /**  */
  interviewId?: string;

  /**  */
  candidateId?: string;

  /**  */
  questionId?: string;

  /**  */
  contentType?: string;
}

export interface ActionDto {
  /**  */
  actionId?: string;

  /**  */
  emailTemplateId?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  hasCallReminder?: boolean;

  /**  */
  interviewStatuses?: InterviewStatus[];
}

export interface AdditionalInfoRequest {
  /**  */
  obstacleType?: string;

  /**  */
  obstacleRate?: string;

  /**  */
  hasReport?: boolean;
}

export interface AdditionalInfoResponse {
  /**  */
  obstacleType?: string;

  /**  */
  obstacleRate?: string;

  /**  */
  hasReport?: boolean;
}

export interface AddressModel {
  /**  */
  street?: string;

  /**  */
  city?: string;

  /**  */
  state?: string;

  /**  */
  postalCode?: string;

  /**  */
  country?: string;
}

export interface AdminQuestionChoiceContract {
  /**  */
  isCorrect?: boolean;

  /**  */
  title?: string;
}

export interface AdminQuestionChoiceDto {
  /**  */
  isCorrect?: boolean;

  /**  */
  title?: string;
}

export interface AdminQuestionDto {
  /**  */
  id: string;

  /**  */
  rank?: number;

  /**  */
  question?: string;

  /**  */
  durationMin?: number;

  /**  */
  isCaseMode?: boolean;

  /**  */
  questionType?: QuestionType;

  /**  */
  skill?: string;

  /**  */
  settings?: QuestionDtoSettings;

  /**  */
  tags?: string[];

  /**  */
  images?: string[];

  /**  */
  mediaFiles?: string[];

  /**  */
  programmingLanguage?: string;

  /**  */
  score?: number;

  /**  */
  avatarVideoUrl?: string;

  /**  */
  choices?: AdminQuestionChoiceDto[];
}

export interface AiQuestionChoice {
  /**  */
  title?: string;

  /**  */
  isCorrect?: boolean;
}

export interface AiQuestionModel {
  /**  */
  question?: string;

  /**  */
  time?: number;

  /**  */
  rank?: number;

  /**  */
  skill?: string;

  /**  */
  ratingCriteria?: string;

  /**  */
  questionType?: QuestionType;

  /**  */
  questionGenerationType?: QuestionGenerationType;

  /**  */
  choices?: AiQuestionChoice[];

  /**  */
  tags?: string[];
}

export interface AiQuestionsRequest {
  /**  */
  title?: string;

  /**  */
  jobDescription?: string;

  /**  */
  questionGenerationType?: QuestionGenerationType;

  /**  */
  olderQuestions?: string[];

  /**  */
  type?: InterviewType;

  /**  */
  language?: string;
}

export interface AiScorePutRequest {
  /**  */
  aiScore?: number;
}

export interface AnswerDetailContract {
  /**  */
  selectedAnswers?: SelectedAnswerContract[];

  /**  */
  openEndedAnswer?: string;

  /**  */
  otherAnswer?: string;

  /**  */
  score?: number;
}

export interface AnswerDto {
  /**  */
  id: string;

  /**  */
  videoUrl?: string;

  /**  */
  fileUrl?: string;

  /**  */
  videoDuration?: number;

  /**  */
  transcript?: string;

  /**  */
  aiReview?: string;

  /**  */
  review?: string;

  /**  */
  reviewerId?: string;

  /**  */
  aiScore?: number;

  /**  */
  aiMaxScore?: number;

  /**  */
  comment?: string;

  /**  */
  pluses?: string[];

  /**  */
  cons?: string[];

  /**  */
  needs?: string[];

  /**  */
  completedAt?: string;

  /**  */
  startedAt?: string;

  /**  */
  showPossibleAnswerButton?: boolean;

  /**  */
  ignoreRating?: boolean;

  /**  */
  mentionedTag?: string[];

  /**  */
  selectedAnswers?: SelectedAnswerDto[];

  /**  */
  openEndedAnswer?: string;

  /**  */
  otherAnswer?: string;

  /**  */
  isSkipped?: boolean;

  /**  */
  scoreAnswer?: number;

  /**  */
  note?: string;

  /**  */
  settings?: QuestionSettings;
}

export interface AnswerQuestionRequest {
  /**  */
  videoUrl?: string;

  /**  */
  fileUrl?: string;

  /**  */
  answer?: AnswerDetailContract;

  /**  */
  isCamCapturedVideo?: boolean;

  /**  */
  isSkipped?: boolean;
}

export interface AppleTokenRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  token?: string;
}

export interface ApplyCouponRequest {
  /**  */
  code?: string;

  /**  */
  productType?: ProductType;
}

export interface ApplyCouponResponse {
  /**  */
  isApplied?: boolean;

  /**  */
  error?: string;
}

export interface AuthCheckResponse {
  /**  */
  user?: UserDto;

  /**  */
  userType?: UserType;

  /**  */
  isAuthenticated?: boolean;
}

export interface AuthOtpRequestRequest {
  /**  */
  email?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  phone?: string;
}

export interface AuthOtpRequestResult {
  /**  */
  isOtpSent?: boolean;

  /**  */
  token?: JwtDto;
}

export interface AuthOtpValidationRequest {
  /**  */
  email?: string;

  /**  */
  otpCode?: string;
}

export interface BillingInfoModel {
  /**  */
  country?: string;

  /**  */
  state?: string;

  /**  */
  city?: string;

  /**  */
  district?: string;

  /**  */
  postalCode?: string;

  /**  */
  address1?: string;

  /**  */
  address2?: string;

  /**  */
  taxNumber?: string;

  /**  */
  taxOffice?: string;
}

export interface BoardActionRequest {
  /**  */
  emailTemplateId?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  hasCallReminder?: boolean;

  /**  */
  interviewStatuses?: InterviewStatus[];
}

export interface BoardActionUpdateRequest {
  /**  */
  emailTemplateId?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  hasCallReminder?: boolean;

  /**  */
  interviewStatuses?: InterviewStatus[];
}

export interface BoardAddCandidateRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  sendInvitationMail?: boolean;

  /**  */
  mailTemplateId?: string;

  /**  */
  fileUrl?: string;

  /**  */
  resumeSummary?: string;

  /**  */
  personalInfo?: PersonalInformation;

  /**  */
  workExperience?: WorkExperienceInfo[];

  /**  */
  educationInfo?: Education[];
}

export interface BoardBasicDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  createdAt?: string;

  /**  */
  createdBy?: string[];
}

export interface BoardBasicDtoPagedResponseDto {
  /**  */
  data?: BoardBasicDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface BoardCandidateAdditionalInfoRequest {
  /**  */
  fieldName?: string;

  /**  */
  fieldValue?: string;
}

export interface BoardCandidateAdditionalInfoResponse {
  /**  */
  fieldName?: string;

  /**  */
  fieldValue?: any | null;
}

export interface BoardCandidateAdditionalInfoUpdateRequest {
  /**  */
  fieldValue?: string;
}

export interface BoardCandidateCv {
  /**  */
  fileUrl?: string;

  /**  */
  resumeSummary?: string;

  /**  */
  AiAnalysis?: BoardCandidateCvAiAnalysis;

  /**  */
  personalInfo?: PersonalInformation;

  /**  */
  workExperience?: WorkExperienceInfo[];

  /**  */
  educationInfo?: Education[];
}

export interface BoardCandidateCvAiAnalysis {
  /**  */
  resumeSummaryScore?: number;

  /**  */
  resumeSummaryPros?: string[];

  /**  */
  resumeSummaryCons?: string[];

  /**  */
  personalInfoScore?: number;

  /**  */
  personalInfoPros?: string[];

  /**  */
  personalInfoCons?: string[];

  /**  */
  workExperienceScore?: number;

  /**  */
  workExperiencePros?: string[];

  /**  */
  workExperienceCons?: string[];

  /**  */
  educationScore?: number;

  /**  */
  educationPros?: string[];

  /**  */
  educationCons?: string[];
}

export interface BoardCandidateCvFileRequest {
  /**  */
  fileUrl: string;
}

export interface BoardCandidateCvRequest {
  /**  */
  fileUrl?: string;

  /**  */
  resumeSummary?: string;

  /**  */
  personalInfo?: PersonalInformation;

  /**  */
  workExperience?: WorkExperienceInfo[];

  /**  */
  educationInfo?: Education[];
}

export interface BoardCandidateCvScoreRequest {
  /**  */
  resumeSummaryScore?: number;

  /**  */
  personalInfoScore?: number;

  /**  */
  workExperienceScore?: number;

  /**  */
  educationScore?: number;
}

export interface BoardCandidateDto {
  /**  */
  candidateId?: string;

  /**  */
  email?: string;

  /**  */
  candidate?: CandidateBasicDto;

  /**  */
  candidateHistory?: CandidateHistoryDto[];

  /**  */
  columnId?: string;

  /**  */
  columnGroupId?: string;

  /**  */
  cvMatchScore?: number;
}

export interface BoardCandidateLogDto {
  /**  */
  name?: string;

  /**  */
  email?: string;

  /**  */
  candidateId?: string;

  /**  */
  columnGroupStatuses?: CandidateLogColumnGroup[];
}

export interface BoardCandidateLogDtoPagedResponseDto {
  /**  */
  data?: BoardCandidateLogDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface BoardCandidateRequest {
  /**  */
  candidateId?: string;

  /**  */
  targetColumnId?: string;

  /**  */
  targetColumnGroupId?: string;

  /**  */
  positionIndex?: number;

  /**  */
  interviewStatus?: InterviewStatus;
}

export interface BoardColumnGroupRequest {
  /**  */
  name?: string;

  /**  */
  interviewId?: string;
}

export interface BoardColumnPositionRequest {
  /**  */
  positionIndex?: number;
}

export interface BoardColumnRequest {
  /**  */
  name?: string;

  /**  */
  action?: BoardActionRequest;

  /**  */
  managerNotifications?: ManagerNotificationRequest[];
}

export interface BoardCvAiAnalyzeQueueResponse {
  /**  */
  isWaiting?: boolean;
}

export interface BoardCvExtractionQueueResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  cv?: BoardCandidateCv;
}

export interface BoardDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  name?: string;

  /**  */
  createdAt?: string;

  /**  */
  createdByUser?: string;

  /**  */
  department?: DepartmentType;

  /**  */
  positionDescription?: string;

  /**  */
  columnGroups?: ColumnGroupDto[];
}

export interface BoardRequest {
  /**  */
  name?: string;

  /**  */
  interviewId?: string;

  /**  */
  department?: DepartmentType;

  /**  */
  positionDescription?: string;
}

export interface BoardUpdateColumnGroupRequest {
  /**  */
  name?: string;
}

export interface BoardUpdateColumnRequest {
  /**  */
  name?: string;

  /**  */
  action?: BoardActionUpdateRequest;

  /**  */
  managerNotifications?: ManagerNotificationUpdateRequest[];
}

export interface BoardUpdateRequest {
  /**  */
  name?: string;

  /**  */
  department?: DepartmentType;

  /**  */
  positionDescription?: string;

  /**  */
  interviewId?: string;
}

export interface CandidateAttendRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;
}

export interface CandidateBasicDto {
  /**  */
  id: string;

  /**  */
  interviewId: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  rating?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  aiRating?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  reAnalyzing?: boolean;

  /**  */
  certificateUrl?: string;

  /**  */
  completedAt?: string;

  /**  */
  refreshAttempts?: number;

  /**  */
  tabChangesCount?: number;

  /**  */
  isRedFlag?: boolean;

  /**  */
  odiBotTranscript?: string;

  /**  */
  listType?: CandidateListType;

  /**  */
  cvScore?: number;

  /**  */
  urls?: UrlModel;
}

export interface CandidateBasicDtoPagedResponseDto {
  /**  */
  data?: CandidateBasicDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface CandidateBoardDto {
  /**  */
  id: string;

  /**  */
  interviewId: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  rating?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  aiRating?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  reAnalyzing?: boolean;

  /**  */
  certificateUrl?: string;

  /**  */
  completedAt?: string;

  /**  */
  refreshAttempts?: number;

  /**  */
  tabChangesCount?: number;

  /**  */
  isRedFlag?: boolean;

  /**  */
  odiBotTranscript?: string;

  /**  */
  listType?: CandidateListType;

  /**  */
  cvScore?: number;

  /**  */
  urls?: UrlModel;

  /**  */
  interviews?: InterviewBoardDto[];
}

export interface CandidateCompanyDto {
  /**  */
  id: string;

  /**  */
  name?: string;

  /**  */
  logoUrl?: string;

  /**  */
  webSite?: string;

  /**  */
  phone?: string;
}

export interface CandidateDetailResponse {
  /**  */
  candidate?: CandidateDto;

  /**  */
  hasNext?: boolean;

  /**  */
  hasPrevious?: boolean;

  /**  */
  nextId?: string;

  /**  */
  previousId?: string;

  /**  */
  currentIndex?: number;

  /**  */
  totalCount?: number;
}

export interface CandidateDto {
  /**  */
  id: string;

  /**  */
  interviewId: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  rating?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  aiRating?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  reAnalyzing?: boolean;

  /**  */
  certificateUrl?: string;

  /**  */
  completedAt?: string;

  /**  */
  refreshAttempts?: number;

  /**  */
  tabChangesCount?: number;

  /**  */
  isRedFlag?: boolean;

  /**  */
  odiBotTranscript?: string;

  /**  */
  listType?: CandidateListType;

  /**  */
  cvScore?: number;

  /**  */
  urls?: UrlModel;

  /**  */
  shareLinks?: object;

  /**  */
  questionAnswers?: QuestionAnswerDto[];

  /**  */
  feedback?: string;

  /**  */
  totalAnswerTime?: number;

  /**  */
  categorizedQuestions?: InterviewCategorizedQuestionDto[];

  /**  */
  language?: string;

  /**  */
  languageTestFeedback?: LanguageTestFeedbackModelDto;

  /**  */
  roleBasedTestFeedback?: RoleBasedTestFeedbackModelDto;

  /**  */
  interviewType?: InterviewType;

  /**  */
  ratedHistory?: FeedbackAndRatingHistory[];

  /**  */
  feedbackHistory?: FeedbackAndRatingHistory[];

  /**  */
  candidateFeedbackHistory?: CandidateFeedbackHistoryDto[];

  /**  */
  candidateSuggestion?: CandidateSuggestionDto;
}

export interface CandidateFeedbackHistoryDto {
  /**  */
  isLike?: boolean;

  /**  */
  questionId?: string;

  /**  */
  feedback?: string;

  /**  */
  createdAt?: string;
}

export interface CandidateHistoryDto {
  /**  */
  id: string;

  /**  */
  interviewId: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  rating?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  aiRating?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  reAnalyzing?: boolean;

  /**  */
  certificateUrl?: string;

  /**  */
  completedAt?: string;

  /**  */
  refreshAttempts?: number;

  /**  */
  tabChangesCount?: number;

  /**  */
  isRedFlag?: boolean;

  /**  */
  odiBotTranscript?: string;

  /**  */
  listType?: CandidateListType;

  /**  */
  cvScore?: number;

  /**  */
  urls?: UrlModel;

  /**  */
  cvMatchScore?: number;
}

export interface CandidateInColumnPositionResponse {
  /**  */
  candidate?: CandidateBoardDto;

  /**  */
  communications?: CommunicationRecordDto[];

  /**  */
  hasNext?: boolean;

  /**  */
  hasPrevious?: boolean;

  /**  */
  nextId?: string;

  /**  */
  previousId?: string;

  /**  */
  currentIndex?: number;

  /**  */
  totalCount?: number;
}

export interface CandidateLogColumnGroup {
  /**  */
  date?: string;

  /**  */
  columnGroupId?: string;

  /**  */
  interviewName?: string;

  /**  */
  candidateStatus?: InterviewStatus;
}

export interface CandidateProfileImageRequest {
  /**  */
  fileKey?: string;
}

export interface CandidateProfileRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  phone?: string;
}

export interface CandidatePublicDto {
  /**  */
  id: string;

  /**  */
  interviewId: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  rating?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  aiRating?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  reAnalyzing?: boolean;

  /**  */
  certificateUrl?: string;

  /**  */
  completedAt?: string;

  /**  */
  refreshAttempts?: number;

  /**  */
  tabChangesCount?: number;

  /**  */
  isRedFlag?: boolean;

  /**  */
  odiBotTranscript?: string;

  /**  */
  listType?: CandidateListType;

  /**  */
  cvScore?: number;

  /**  */
  urls?: UrlModel;

  /**  */
  company?: CandidateCompanyDto;

  /**  */
  hasVideo?: boolean;

  /**  */
  hasFile?: boolean;

  /**  */
  hasMultipleChoice?: boolean;

  /**  */
  hasMultipleSelection?: boolean;

  /**  */
  hasOpenEnded?: boolean;
}

export interface CandidateSkillDto {
  /**  */
  name?: string;

  /**  */
  score?: number;
}

export interface CandidateSuggestionDto {
  /**  */
  candidateSkills?: CandidateSkillDto[];

  /**  */
  generalEvaluation?: string;
}

export interface CategorizeInterviewCandidatesDeleteRequest {
  /**  */
  id: string;

  /**  */
  status?: InterviewStatus;
}

export interface CategorizeInterviewCandidatesRequest {
  /**  */
  status?: InterviewStatus;

  /**  */
  count?: number;

  /**  */
  categorizedName: string;
}

export interface CategorizedCandidatesModel {
  /**  */
  id?: string;

  /**  */
  name: string;

  /**  */
  count: number;

  /**  */
  status?: InterviewStatus;
}

export interface CategorizedQuestionAnswerDto {
  /**  */
  skill?: string;

  /**  */
  icon?: string;

  /**  */
  averageRating?: number;

  /**  */
  questionAnswers?: QuestionAnswerDto[];
}

export interface CategorizedQuestionPublicAnswerDto {
  /**  */
  skill?: string;

  /**  */
  averageRating?: number;
}

export interface CertificateRequest {
  /**  */
  certificateName?: string;

  /**  */
  issuingOrganization?: string;

  /**  */
  issueDate?: string;

  /**  */
  explanation?: string;
}

export interface CertificateResponse {
  /**  */
  certificateName?: string;

  /**  */
  issuingOrganization?: string;

  /**  */
  issueDate?: string;

  /**  */
  explanation?: string;
}

export interface CertificationModel {
  /**  */
  title?: string;

  /**  */
  dateObtained?: string;

  /**  */
  expiryDate?: string;

  /**  */
  certifyingAuthority?: string;
}

export interface ChangePasswordRequest {
  /**  */
  oldPassword?: string;

  /**  */
  newPassword?: string;
}

export interface ChoiceReportDto {
  /**  */
  choice?: string;

  /**  */
  count?: number;

  /**  */
  percentage?: number;
}

export interface CoachDislikeRequestModel {
  /**  */
  questionId?: string;

  /**  */
  feedback?: string;
}

export interface CoachLikeRequestModel {
  /**  */
  questionId?: string;

  /**  */
  feedback?: string;
}

export interface ColumnDto {
  /**  */
  columnId?: string;

  /**  */
  name?: string;

  /**  */
  isDefault?: boolean;

  /**  */
  candidates?: BoardCandidateDto[];

  /**  */
  action?: ActionDto;

  /**  */
  categorizedCandidates?: CategorizedCandidatesModel[];

  /**  */
  managerNotifications?: ManagerNotificationDto[];
}

export interface ColumnGroupDto {
  /**  */
  columnGroupId?: string;

  /**  */
  name?: string;

  /**  */
  interviewId?: string;

  /**  */
  columns?: ColumnDto[];
}

export interface ColumnGroupInterviewStatus {
  /**  */
  status?: InterviewStatus;

  /**  */
  isDisabled?: boolean;

  /**  */
  value?: boolean;
}

export interface ColumnGroupInterviewStatusResponse {
  /**  */
  statuses?: ColumnGroupInterviewStatus[];
}

export interface CommitmentDto {
  /**  */
  totalResponses?: number;

  /**  */
  detachedPercent?: number;

  /**  */
  neutralPercent?: number;

  /**  */
  committedPercent?: number;

  /**  */
  detachedCount?: number;

  /**  */
  neutralCount?: number;

  /**  */
  committedCount?: number;
}

export interface CommunicationRecordDto {
  /**  */
  channel?: SendInvitationChannel;

  /**  */
  templateName?: string;

  /**  */
  sentAt?: string;

  /**  */
  interviewId?: string;
}

export interface CompanyAdminUpdateRequest {
  /**  */
  name?: string;
}

export interface CompanyBasicDto {
  /**  */
  id: string;

  /**  */
  name?: string;

  /**  */
  logoUrl?: string;

  /**  */
  webSite?: string;

  /**  */
  phone?: string;

  /**  */
  location?: string;

  /**  */
  industry?: IndustryType;

  /**  */
  teamSize?: string;

  /**  */
  contactPerson?: ContactPersonModel;

  /**  */
  billingInfo?: BillingInfoModel;
}

export interface CompanyBasicDtoPagedResponseNextPageDto {
  /**  */
  data?: CompanyBasicDto[];

  /**  */
  nextToken?: string;

  /**  */
  total?: number;
}

export interface CompanyChangeRequest {
  /**  */
  name?: string;

  /**  */
  logoUrl?: string;

  /**  */
  webSite?: string;

  /**  */
  phone?: string;

  /**  */
  isDemo?: boolean;

  /**  */
  industry?: IndustryType;

  /**  */
  location?: string;

  /**  */
  teamSize?: string;
}

export interface CompanyDetailDto {
  /**  */
  id: string;

  /**  */
  name?: string;

  /**  */
  logoUrl?: string;

  /**  */
  webSite?: string;

  /**  */
  phone?: string;

  /**  */
  location?: string;

  /**  */
  industry?: IndustryType;

  /**  */
  teamSize?: string;

  /**  */
  contactPerson?: ContactPersonModel;

  /**  */
  billingInfo?: BillingInfoModel;

  /**  */
  usageRecord?: UsageRecordDto;

  /**  */
  usageLimit?: UsageLimitDto;

  /**  */
  users?: UserBasicDto[];
}

export interface CompanyLogoRequest {
  /**  */
  fileKey?: string;
}

export interface CompanyLogoUrlResponse {
  /**  */
  logoUrl?: string;
}

export interface CompanyShareRequest {
  /**  */
  userIds?: string[];
}

export interface CompanySmtpSettingsRequest {
  /**  */
  fromName?: string;

  /**  */
  fromEmail?: string;

  /**  */
  host?: string;

  /**  */
  port?: number;

  /**  */
  username?: string;

  /**  */
  password?: string;

  /**  */
  encryption?: SmtpEncryptionType;

  /**  */
  isEnabled?: boolean;
}

export interface CompanySmtpSettingsResponse {
  /**  */
  companyId?: string;

  /**  */
  fromName?: string;

  /**  */
  fromEmail?: string;

  /**  */
  host?: string;

  /**  */
  port?: number;

  /**  */
  username?: string;

  /**  */
  encryption?: SmtpEncryptionType;

  /**  */
  isEnabled?: boolean;

  /**  */
  updatedAt?: string;
}

export interface CompanyUpdateRequest {
  /**  */
  company?: CompanyChangeRequest;

  /**  */
  passwordChange?: PasswordChangeRequest;
}

export interface CompanyUsageLimitDto {
  /**  */
  companyId?: string;

  /**  */
  companyName?: string;

  /**  */
  usageLimit?: UsageLimitModel;

  /**  */
  usageRecord?: UsageRecordModel;
}

export interface CompanyUsageLimitUpdateRequest {
  /**  */
  interviewCandidateLimit?: number;

  /**  */
  smsLimit?: number;

  /**  */
  emailLimit?: number;

  /**  */
  callReminderLimit?: number;
}

export interface CompletedInterviewBasicDto {
  /**  */
  id: string;

  /**  */
  title?: string;

  /**  */
  detail?: string;

  /**  */
  questionCount?: number;

  /**  */
  status?: Status;

  /**  */
  createdBy?: string;

  /**  */
  createdAt?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  type?: InterviewType;

  /**  */
  isQuestionRetryable?: boolean;

  /**  */
  instructionVideoUrl?: string;

  /**  */
  informationalText?: string;

  /**  */
  isTrainingMode?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionDetectionEnabled?: boolean;

  /**  */
  jobDescription?: string;

  /**  */
  totalDuration?: number;

  /**  */
  invitationSetting?: InvitationSettingDto;

  /**  */
  interviewSettings?: InterviewSettingsDto;

  /**  */
  isTemplateInterview?: boolean;

  /**  */
  scheduleStatus?: InterviewScheduleStatus;

  /**  */
  candidateId?: string;
}

export interface ConfirmPaymentRequest {
  /**  */
  token?: string;

  /**  */
  paymentProvider?: PaymentProvider;

  /**  */
  productId?: string;
}

export interface ContactInfoModel {
  /**  */
  id?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  address?: AddressModel;

  /**  */
  linkedin?: string;

  /**  */
  github?: string;
}

export interface ContactPersonModel {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  title?: string;

  /**  */
  department?: string;

  /**  */
  description?: string;
}

export interface CouponDto {
  /**  */
  code?: string;

  /**  */
  discount?: number;

  /**  */
  discountType?: DiscountType;

  /**  */
  productType?: ProductType;

  /**  */
  usageLimit?: number;

  /**  */
  usageCount?: number;

  /**  */
  createdAt?: string;

  /**  */
  expireAt?: string;

  /**  */
  isActive?: boolean;
}

export interface CouponDtoPagedResponseNextPageDto {
  /**  */
  data?: CouponDto[];

  /**  */
  nextToken?: string;

  /**  */
  total?: number;
}

export interface CreateAndUpdateCouponAdminRequest {
  /**  */
  code?: string;

  /**  */
  discount?: number;

  /**  */
  discountType?: DiscountType;

  /**  */
  productType?: ProductType;

  /**  */
  usageLimit?: number;

  /**  */
  expireAt?: string;
}

export interface CreateTagRequest {
  /**  */
  question?: string;

  /**  */
  previousTags?: string[];
}

export interface CreateTagResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  data?: string[];
}

export interface CreateTrainingInterviewResponse {
  /**  */
  interviewId?: string;

  /**  */
  token?: string;

  /**  */
  securityCode?: string;

  /**  */
  candidateId?: string;
}

export interface CvAnalysisBasicDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  email?: string;

  /**  */
  overallPoint?: number;

  /**  */
  maxOverallPoint?: number;

  /**  */
  createdAt?: string;

  /**  */
  personalData?: SectionDataModel;

  /**  */
  shareLinks?: object;

  /**  */
  certificateUrl?: string;
}

export interface CvAnalysisDto {
  /**  */
  id: string;

  /**  */
  name?: string;

  /**  */
  email?: string;

  /**  */
  overallPoint?: number;

  /**  */
  maxOverallPoint?: number;

  /**  */
  personalData?: SectionDataModel;

  /**  */
  shareLinks?: object;

  /**  */
  certificateUrl?: string;

  /**  */
  review?: string;

  /**  */
  pluses?: string[];

  /**  */
  cons?: string[];

  /**  */
  summary?: SectionDataModel;

  /**  */
  education?: SectionDataModel;

  /**  */
  experience?: SectionDataModel;

  /**  */
  skills?: SectionDataModel;

  /**  */
  languages?: SectionDataModel;

  /**  */
  certificates?: SectionDataModel;
}

export interface CvAnalysisFailedResponse {
  /**  */
  isFailed?: boolean;

  /**  */
  message?: string;
}

export interface CvAnalysisPublicDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  email?: string;

  /**  */
  overallPoint?: number;

  /**  */
  maxOverallPoint?: number;

  /**  */
  createdAt?: string;

  /**  */
  personalData?: SectionDataModel;

  /**  */
  shareLinks?: object;

  /**  */
  certificateUrl?: string;

  /**  */
  review?: string;

  /**  */
  summary?: SectionPublicDataModel;

  /**  */
  education?: SectionPublicDataModel;

  /**  */
  experience?: SectionPublicDataModel;

  /**  */
  skills?: SectionPublicDataModel;

  /**  */
  languages?: SectionPublicDataModel;

  /**  */
  certificates?: SectionPublicDataModel;

  /**  */
  successPosition?: number;
}

export interface CvAnalysisResponse {
  /**  */
  cvAnalysis?: CvAnalysisDto;

  /**  */
  cv?: CvDto;

  /**  */
  isPaid?: boolean;

  /**  */
  isWaiting?: boolean;

  /**  */
  failed?: CvAnalysisFailedResponse;

  /**  */
  products?: ProductDto[];
}

export interface CvDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  contact?: ContactInfoModel;

  /**  */
  summary?: string;

  /**  */
  skills?: string[];

  /**  */
  experience?: ExperienceModel[];

  /**  */
  education?: EducationModel[];

  /**  */
  certifications?: CertificationModel[];

  /**  */
  languages?: LanguageModel[];

  /**  */
  projects?: ProjectModel[];
}

export interface CvImprovementLink {
  /**  */
  url?: string;

  /**  */
  title?: string;
}

export interface CvImprovementSuggestion {
  /**  */
  content?: string;

  /**  */
  link?: CvImprovementLink;
}

export interface CvResponse {
  /**  */
  personalInfo?: PersonalInformationResponse;

  /**  */
  workExperience?: WorkExperienceResponse[];

  /**  */
  education?: EducationResponse[];

  /**  */
  foreignLanguage?: ForeignLanguageResponse[];

  /**  */
  certificate?: CertificateResponse[];

  /**  */
  additionalInfo?: AdditionalInfoResponse[];
}

export interface CvSectionPossibleImprovementsQueueResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  improvements?: CvImprovementSuggestion[];
}

export interface CvUpdateRequest {
  /**  */
  personalInfo?: PersonalInformationRequest;

  /**  */
  workExperience?: WorkExperienceRequest[];

  /**  */
  education?: EducationRequest[];

  /**  */
  foreignLanguage?: ForeignLanguageRequest[];

  /**  */
  certificate?: CertificateRequest[];

  /**  */
  additionalInfo?: AdditionalInfoRequest[];
}

export interface DailyInterviewsResponse {
  /**  */
  interviews?: InterviewBasicDto[];

  /**  */
  createdBy?: UserBasicDto[];
}

export interface DeleteCandidatesFromMultipleInterviewsRequest {
  /** Dictionary where key is interview ID and value is list of candidate IDs to delete from that interview. */
  interviewCandidateIds?: object;
}

export interface DepartmentScoreDto {
  /**  */
  department?: string;

  /**  */
  scores?: DimensionScoreDto[];
}

export interface DimensionQuestionDetailReportDto {
  /**  */
  questions?: QuestionDetailItemDto[];
}

export interface DimensionReportDto {
  /**  */
  dimensions?: DimensionReportItemDto[];
}

export interface DimensionReportItemDto {
  /**  */
  dimension?: string;

  /**  */
  previousChange?: number;

  /**  */
  supportersPercent?: number;

  /**  */
  passivesPercent?: number;

  /**  */
  detractorsPercent?: number;

  /**  */
  averageScore?: number;
}

export interface DimensionScoreDto {
  /**  */
  value?: number;

  /**  */
  dimension?: string;
}

export interface DislikeRequestModel {
  /**  */
  section?: CvSection;

  /**  */
  feedback?: string;
}

export interface Education {
  /**  */
  educationLevel?: string;

  /**  */
  universityName?: string;

  /**  */
  department?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  isStillStudying?: boolean;
}

export interface EducationModel {
  /**  */
  degree?: string;

  /**  */
  institution?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  gpa?: string;
}

export interface EducationRequest {
  /**  */
  educationLevel?: string;

  /**  */
  universityName?: string;

  /**  */
  department?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  isStillStudying?: boolean;
}

export interface EducationResponse {
  /**  */
  educationLevel?: string;

  /**  */
  universityName?: string;

  /**  */
  department?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  isStillStudying?: boolean;
}

export interface EmailTemplateSettingsRequest {
  /**  */
  isHideJoinInterviewButton?: boolean;
}

export interface EmailTemplateSettingsUpdateRequest {
  /**  */
  isHideJoinInterviewButton?: boolean;
}

export interface EmotionData {
  /**  */
  second?: number;

  /**  */
  angry?: number;

  /**  */
  disgust?: number;

  /**  */
  fear?: number;

  /**  */
  happy?: number;

  /**  */
  sad?: number;

  /**  */
  surprise?: number;

  /**  */
  neutral?: number;
}

export interface EmotionResponse {
  /**  */
  hasData?: boolean;

  /**  */
  isEmpty?: boolean;

  /**  */
  emotions?: EmotionData[];
}

export interface EventData {
  /**  */
  video_id?: string;

  /**  */
  url?: string;

  /**  */
  gif_download_url?: string;

  /**  */
  video_share_page_url?: string;

  /**  */
  folder_id?: string;

  /**  */
  callback_id?: string;
}

export interface ExcelImportRequest {
  /**  */
  fileUrl?: string;

  /**  */
  mailTemplateId?: string;

  /**  */
  sendInvitation?: boolean;
}

export interface ExcelImportResponse {
  /**  */
  invalidItems?: number;

  /**  */
  duplicatedItems?: number;

  /**  */
  duplicatedEmails?: string[];
}

export interface ExperienceModel {
  /**  */
  companyLogoUrl?: string;

  /**  */
  jobTitle?: string;

  /**  */
  company?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  location?: string;

  /**  */
  responsibilities?: string;
}

export interface FeedbackAndRatingHistory {
  /**  */
  fullName?: string;

  /**  */
  feedback?: string;

  /**  */
  rate?: number;

  /**  */
  createdAt?: string;

  /**  */
  userId?: string;
}

export interface ForeignLanguageRequest {
  /**  */
  language?: string;

  /**  */
  level?: string;
}

export interface ForeignLanguageResponse {
  /**  */
  language?: string;

  /**  */
  level?: string;
}

export interface ForgotRequest {
  /**  */
  email?: string;

  /**  */
  captchaToken?: string;

  /**  */
  userType?: UserType;
}

export interface FunnelDto {
  /**  */
  stages?: FunnelStageDto[];
}

export interface FunnelInterviewStatusDetail {
  /**  */
  count?: number;

  /**  */
  totalCount?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  columnName?: string;

  /**  */
  categorizedCandidatesModels?: CategorizedCandidatesModel[];
}

export interface FunnelStageDto {
  /**  */
  stageName?: string;

  /**  */
  interviewId?: string;

  /**  */
  candidateCount?: number;

  /**  */
  candidatePercentage?: number;
}

export interface GeneralDto {
  /**  */
  generalSatisfactionPercent?: number;

  /**  */
  participationRatePercent?: number;

  /**  */
  participationCount?: number;

  /**  */
  totalInvitedCount?: number;
}

export interface GetCouponCodeResponse {
  /**  */
  code?: string;
}

export interface GoogleTokenRequest {
  /**  */
  code?: string;

  /**  */
  redirectUrl?: string;
}

export interface HeyGenWebhookRequest {
  /**  */
  event_type?: string;

  /**  */
  event_data?: EventData;
}

export interface HttpValidationProblemDetails {
  /**  */
  type?: string;

  /**  */
  title?: string;

  /**  */
  status?: number;

  /**  */
  detail?: string;

  /**  */
  instance?: string;

  /**  */
  errors?: object;
}

export interface InformationalTextRequest {
  /**  */
  informationalText?: string;
}

export interface InstructionVideoRequest {
  /**  */
  url?: string;
}

export interface IntegrationCandidateDetailResponse {
  /**  */
  candidate?: CandidateDto;

  /**  */
  hasNext?: boolean;

  /**  */
  hasPrevious?: boolean;

  /**  */
  nextId?: string;

  /**  */
  previousId?: string;

  /**  */
  currentIndex?: number;

  /**  */
  totalCount?: number;
}

export interface IntegrationInviteCandidateRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  sendInvitationMail?: boolean;

  /**  */
  sendInvitationSms?: boolean;
}

export interface InterviewBasicDto {
  /**  */
  id: string;

  /**  */
  title?: string;

  /**  */
  detail?: string;

  /**  */
  questionCount?: number;

  /**  */
  status?: Status;

  /**  */
  createdBy?: string;

  /**  */
  createdAt?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  type?: InterviewType;

  /**  */
  isQuestionRetryable?: boolean;

  /**  */
  instructionVideoUrl?: string;

  /**  */
  informationalText?: string;

  /**  */
  isTrainingMode?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionDetectionEnabled?: boolean;

  /**  */
  jobDescription?: string;

  /**  */
  totalDuration?: number;

  /**  */
  invitationSetting?: InvitationSettingDto;

  /**  */
  interviewSettings?: InterviewSettingsDto;

  /**  */
  isTemplateInterview?: boolean;

  /**  */
  scheduleStatus?: InterviewScheduleStatus;
}

export interface InterviewBasicDtoPagedResponseDto {
  /**  */
  data?: InterviewBasicDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface InterviewBoardDto {
  /**  */
  id: string;

  /**  */
  title?: string;

  /**  */
  detail?: string;

  /**  */
  questionCount?: number;

  /**  */
  status?: Status;

  /**  */
  createdBy?: string;

  /**  */
  createdAt?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  type?: InterviewType;

  /**  */
  isQuestionRetryable?: boolean;

  /**  */
  instructionVideoUrl?: string;

  /**  */
  informationalText?: string;

  /**  */
  isTrainingMode?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionDetectionEnabled?: boolean;

  /**  */
  jobDescription?: string;

  /**  */
  totalDuration?: number;

  /**  */
  invitationSetting?: InvitationSettingDto;

  /**  */
  interviewSettings?: InterviewSettingsDto;

  /**  */
  isTemplateInterview?: boolean;

  /**  */
  scheduleStatus?: InterviewScheduleStatus;

  /**  */
  questionAnswers?: QuestionAnswerDto[];

  /**  */
  selectedCandidate?: CandidateBasicDto;
}

export interface InterviewCategorizedQuestionDto {
  /**  */
  skill?: string;

  /**  */
  averageRating?: number;

  /**  */
  questionAnswers?: QuestionAnswerDto[];
}

export interface InterviewDetailResponse {
  /**  */
  interview?: InterviewBasicDto;

  /**  */
  createdBy?: UserBasicDto;

  /**  */
  candidateCount?: number;

  /**  */
  completedCandidateCount?: number;

  /**  */
  nextInterviewId?: string;

  /**  */
  previousInterviewId?: string;
}

export interface InterviewImprovementLink {
  /**  */
  url?: string;

  /**  */
  title?: string;
}

export interface InterviewImprovementSuggestion {
  /**  */
  content?: string;

  /**  */
  link?: InterviewImprovementLink;
}

export interface InterviewQuestionRequest {
  /**  */
  skill?: string;

  /**  */
  question?: string;

  /**  */
  durationMinutes?: number;

  /**  */
  rank?: number;

  /**  */
  isCaseMode?: boolean;

  /**  */
  tags?: string[];

  /**  */
  imageFileKeys?: string[];

  /**  */
  mediaFileKeys?: string[];

  /**  */
  questionType?: QuestionType;

  /**  */
  choices?: AdminQuestionChoiceDto[];

  /**  */
  settings?: InterviewQuestionSettings;

  /**  */
  programmingLanguage?: string;
}

export interface InterviewQuestionResponse {
  /**  */
  question?: QuestionDto;

  /**  */
  remainingQuestions?: number;

  /**  */
  answeredQuestions?: number;

  /**  */
  remainingTime?: number;

  /**  */
  penaltyApplied?: boolean;

  /**  */
  interviewEnded?: boolean;

  /**  */
  isCamRecordingEnabled?: boolean;

  /**  */
  isSuggestionEnabled?: boolean;
}

export interface InterviewQuestionSettings {
  /**  */
  ignoreRating?: boolean;

  /**  */
  thinkingTimeSeconds?: number;

  /**  */
  weight?: number;

  /**  */
  retryable?: boolean;

  /**  */
  isAdminQuestion?: boolean;

  /**  */
  hasOtherValue?: boolean;
}

export interface InterviewQuestionsResponse {
  /**  */
  questions?: AdminQuestionDto[];

  /**  */
  isEditable?: boolean;
}

export interface InterviewReplicateRequest {
  /**  */
  title?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  interviewId?: string;
}

export interface InterviewReportDto {
  /**  */
  interviewId?: string;

  /**  */
  title?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  reportLink?: string;

  /**  */
  questions?: QuestionReportDto[];
}

export interface InterviewRequest {
  /**  */
  title?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  detail?: string;

  /**  */
  type?: InterviewType;

  /**  */
  instructionVideoUrl?: string;

  /**  */
  questions?: InterviewQuestionRequest[];

  /**  */
  jobDescription?: string;

  /**  */
  informationalText?: string;

  /**  */
  language?: string;

  /**  */
  interviewSettings?: InterviewSettings;

  /**  */
  department?: DepartmentType;
}

export interface InterviewSettings {
  /**  */
  isShuffleEnabled?: boolean;

  /**  */
  isCamRecordingEnabled?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionAnalysisEnabled?: boolean;

  /**  */
  isSuggestionEnabled?: boolean;

  /**  */
  isAiAvatarEnabled?: boolean;

  /**  */
  isSecurityMeasuresEnabled?: boolean;
}

export interface InterviewSettingsDto {
  /**  */
  isShuffleEnabled?: boolean;

  /**  */
  isCamRecordingEnabled?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionAnalysisEnabled?: boolean;

  /**  */
  isSuggestionEnabled?: boolean;

  /**  */
  isAiAvatarEnabled?: boolean;

  /**  */
  isSecurityMeasuresEnabled?: boolean;
}

export interface InterviewTemplateBasicDto {
  /**  */
  id: string;

  /**  */
  title?: string;

  /**  */
  detail?: string;

  /**  */
  questionCount?: number;

  /**  */
  createdAt?: string;

  /**  */
  type?: InterviewType;

  /**  */
  totalDuration?: number;

  /**  */
  jobDescription?: string;
}

export interface InterviewTemplateBasicDtoPagedResponseDto {
  /**  */
  data?: InterviewTemplateBasicDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface InterviewTemplateDetailResponse {
  /**  */
  template?: InterviewTemplateBasicDto;
}

export interface InterviewTemplateRequest {
  /**  */
  title?: string;

  /**  */
  detail?: string;

  /**  */
  type?: InterviewType;

  /**  */
  questions?: InterviewQuestionRequest[];

  /**  */
  jobDescription?: string;

  /**  */
  language?: string;
}

export interface InvitationSettingDto {
  /**  */
  emailEnabled?: boolean;

  /**  */
  smsEnabled?: boolean;

  /**  */
  phoneCallEnabled?: boolean;

  /**  */
  whatsappEnabled?: boolean;

  /**  */
  emailRemindDays?: number;

  /**  */
  emailRemindHours?: number;

  /**  */
  smsRemindDays?: number;

  /**  */
  smsRemindHours?: number;

  /**  */
  callRemindDays?: number;

  /**  */
  callRemindHours?: number;

  /**  */
  reminderEmailTemplateId?: string;

  /**  */
  reminderSmsTemplateId?: string;

  /**  */
  reminderCallTemplateId?: string;
}

export interface InvitationSettingRequest {
  /**  */
  emailEnabled?: boolean;

  /**  */
  smsEnabled?: boolean;

  /**  */
  phoneCallEnabled?: boolean;

  /**  */
  whatsappEnabled?: boolean;

  /**  */
  emailRemindDays?: number;

  /**  */
  emailRemindHours?: number;

  /**  */
  smsRemindDays?: number;

  /**  */
  smsRemindHours?: number;

  /**  */
  callRemindDays?: number;

  /**  */
  callRemindHours?: number;

  /**  */
  reminderEmailTemplateId?: string;

  /**  */
  reminderSmsTemplateId?: string;

  /**  */
  reminderCallTemplateId?: string;
}

export interface InvitationSettingResponse {
  /**  */
  emailEnabled?: boolean;

  /**  */
  smsEnabled?: boolean;

  /**  */
  phoneCallEnabled?: boolean;

  /**  */
  whatsappEnabled?: boolean;

  /**  */
  callRemindDays?: number;

  /**  */
  callRemindHours?: number;

  /**  */
  emailRemindDays?: number;

  /**  */
  emailRemindHours?: number;

  /**  */
  smsRemindDays?: number;

  /**  */
  smsRemindHours?: number;

  /**  */
  reminderEmailTemplateId?: string;

  /**  */
  reminderSmsTemplateId?: string;

  /**  */
  reminderCallTemplateId?: string;
}

export interface InviteAllCandidatesViaMailRequest {
  /** A list of candidate IDs to be invited to the interview.
If null, all candidates in the interview will be invited. */
  candidateIds?: string[];

  /**  */
  channel?: SendInvitationChannel;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  mailTemplateId?: string;

  /**  */
  phoneCallTemplateId?: string;
}

export interface InviteCandidateRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  sendInvitationMail?: boolean;

  /**  */
  sendInvitationSms?: boolean;

  /**  */
  mailTemplateId?: string;

  /**  */
  meetingLink?: string;

  /**  */
  meetingDate?: string;
}

export interface InviteCandidateResponse {
  /**  */
  totalCount?: number;

  /**  */
  notInvitedCount?: number;
}

export interface InviteCandidateViaMailRequest {
  /** A list of candidate IDs to be invited to the interview.
If null, all candidates in the interview will be invited. */
  candidateIds?: string[];

  /**  */
  channel?: SendInvitationChannel;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  mailTemplateId?: string;

  /**  */
  phoneCallTemplateId?: string;
}

export interface InviteSurveyRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  department?: string;
}

export interface JwtDto {
  /**  */
  token: string;

  /**  */
  refreshToken: string;

  /**  */
  userType: UserType;
}

export interface LanguageModel {
  /**  */
  languageName?: string;

  /**  */
  level?: string;
}

export interface LanguageTestFeedbackModelDto {
  /**  */
  review?: string;

  /**  */
  level?: string;
}

export interface LastCompletedCandidateResponse {
  /**  */
  candidates?: CandidateBasicDto[];

  /**  */
  total?: number;
}

export interface LastInterviewResponse {
  /**  */
  interview?: InterviewBasicDto;

  /**  */
  createdBy?: UserBasicDto;

  /**  */
  candidateCount?: number;

  /**  */
  completedCandidateCount?: number;
}

export interface LikeRequestModel {
  /**  */
  section?: CvSection;

  /**  */
  feedback?: string;
}

export interface LoginByEmailRequest {
  /**  */
  email?: string;

  /**  */
  password?: string;

  /**  */
  captchaToken?: string;
}

export interface MailTemplateDto {
  /**  */
  id?: string;

  /**  */
  culture?: string;

  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  createdAt?: string;

  /**  */
  isDefault?: boolean;

  /**  */
  isSystemTemplate?: boolean;

  /**  */
  type?: TemplateType;

  /**  */
  templateSettings: TemplateSettingsDto;
}

export interface MailTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  type?: TemplateType;

  /**  */
  templateSettings?: EmailTemplateSettingsRequest;
}

export interface ManagerNotificationDto {
  /**  */
  id?: string;

  /**  */
  email?: string;

  /**  */
  fullName?: string;

  /**  */
  smsPhoneNumber?: string;

  /**  */
  whatsappPhoneNumber?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  hasCallReminder?: boolean;

  /**  */
  callPhoneNumber?: string;

  /**  */
  emailTemplateId?: string;
}

export interface ManagerNotificationRequest {
  /**  */
  email?: string;

  /**  */
  fullName?: string;

  /**  */
  smsPhoneNumber?: string;

  /**  */
  whatsappPhoneNumber?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  hasCallReminder?: boolean;

  /**  */
  callPhoneNumber?: string;

  /**  */
  emailTemplateId?: string;
}

export interface ManagerNotificationUpdateRequest {
  /**  */
  email?: string;

  /**  */
  fullName?: string;

  /**  */
  smsPhoneNumber?: string;

  /**  */
  whatsappPhoneNumber?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;

  /**  */
  hasCallReminder?: boolean;

  /**  */
  callPhoneNumber?: string;

  /**  */
  emailTemplateId?: string;
}

export interface NpsDto {
  /**  */
  score?: number;

  /**  */
  totalResponses?: number;

  /**  */
  supportersPercent?: number;

  /**  */
  passivesPercent?: number;

  /**  */
  detractorsPercent?: number;

  /**  */
  supportersCount?: number;

  /**  */
  passivesCount?: number;

  /**  */
  detractorsCount?: number;
}

export interface OdiStartRequest {
  /**  */
  interviewId?: string;

  /**  */
  candidateId?: string;
}

export interface OtpRequestRequest {
  /**  */
  email?: string;
}

export interface OtpValidationResult {
  /**  */
  email?: string;

  /**  */
  otpCode?: string;
}

export interface OutlookAccessTokenRequest {
  /**  */
  accessToken?: string;
}

export interface OutlookTokenRequest {
  /**  */
  code?: string;

  /**  */
  redirectUrl?: string;

  /**  */
  codeVerifier?: string;
}

export interface ParticipationSurveyDto {
  /**  */
  id?: string;

  /**  */
  title?: string;

  /**  */
  description?: string;

  /**  */
  questionCount?: number;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  status?: SurveyParticipationStatus;
}

export interface PasswordChangeRequest {
  /**  */
  oldPassword?: string;

  /**  */
  newPassword?: string;
}

export interface PaymentInitResponseModel {
  /**  */
  conversationId?: string;

  /**  */
  token?: string;

  /**  */
  checkoutFormContent?: string;

  /**  */
  tokenExpireTime?: number;

  /**  */
  isSuccess?: boolean;

  /**  */
  isFree?: boolean;
}

export interface PersonalInformation {
  /**  */
  name?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  title?: string;

  /**  */
  address?: string;

  /**  */
  birthdayDate?: string;
}

export interface PersonalInformationRequest {
  /**  */
  fullName?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  title?: string;

  /**  */
  address?: string;

  /**  */
  birthdayDate?: string;

  /**  */
  socialMedia?: SocialMediaRequest;

  /**  */
  cvUrl?: string;
}

export interface PersonalInformationResponse {
  /**  */
  fullName?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  title?: string;

  /**  */
  address?: string;

  /**  */
  birthdayDate?: string;

  /**  */
  socialMedia?: SocialMediaResponse;

  /**  */
  cvUrl?: string;
}

export interface PhoneCallTemplateDto {
  /**  */
  id?: string;

  /**  */
  culture?: string;

  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  createdAt?: string;

  /**  */
  isDefault?: boolean;

  /**  */
  type?: TemplateType;
}

export interface PhoneCallTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  type?: TemplateType;
}

export interface ProblemDetails {
  /**  */
  type?: string;

  /**  */
  title?: string;

  /**  */
  status?: number;

  /**  */
  detail?: string;

  /**  */
  instance?: string;
}

export interface ProductDto {
  /**  */
  id?: string;

  /**  */
  productType?: ProductType;

  /**  */
  title?: string;

  /**  */
  subTitle?: string;

  /**  */
  description?: string;

  /**  */
  features?: string[];

  /**  */
  price?: number;

  /**  */
  discountedPrice?: number;

  /**  */
  currency?: string;

  /**  */
  rank?: number;

  /**  */
  isPopular?: boolean;

  /**  */
  expireDays?: number;

  /**  */
  unitCount?: number;

  /**  */
  appleId?: string;

  /**  */
  googleId?: string;
}

export interface ProjectModel {
  /**  */
  name?: string;

  /**  */
  description?: string;

  /**  */
  technologies?: string[];

  /**  */
  role?: string;

  /**  */
  link?: string;
}

export interface PromptAdminUpdateRequest {
  /**  */
  content?: string;
}

export interface PromptDto {
  /**  */
  type?: PromptType;

  /**  */
  content?: string;

  /**  */
  createdAt?: string;

  /**  */
  updatedAt?: string;
}

export interface PromptTokenDto {
  /**  */
  key?: string;

  /**  */
  displayName?: string;

  /**  */
  types?: PromptType[];
}

export interface PublicInterviewInfo {
  /**  */
  title?: string;

  /**  */
  companyName?: string;

  /**  */
  questionCount?: number;

  /**  */
  interviewDuration?: number;

  /**  */
  interviewDeadline?: string;
}

export interface PutCandidateFeedbackHistoryRequest {
  /**  */
  isLike?: boolean;

  /**  */
  interviewId?: string;

  /**  */
  questionId?: string;

  /**  */
  feedback?: string;
}

export interface PutCandidateFeedbackRequest {
  /**  */
  feedback?: string;
}

export interface PutCandidateListTypeRequest {
  /**  */
  listType?: CandidateListType;
}

export interface PutCandidateRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  identityNumber?: string;

  /**  */
  sendInvitationMail?: boolean;

  /**  */
  sendInvitationSms?: boolean;

  /**  */
  mailTemplateId?: string;
}

export interface PutCandidateStatusRequest {
  /**  */
  status?: InterviewStatus;
}

export interface PutIdentityNumberRequest {
  /**  */
  identityNumber?: string;
}

export interface PutQuestionNoteRequest {
  /**  */
  note?: string;
}

export interface QuestionAnswerDto {
  /**  */
  id: string;

  /**  */
  rank?: number;

  /**  */
  question?: string;

  /**  */
  durationMin?: number;

  /**  */
  isCaseMode?: boolean;

  /**  */
  questionType?: QuestionType;

  /**  */
  skill?: string;

  /**  */
  settings?: QuestionDtoSettings;

  /**  */
  tags?: string[];

  /**  */
  images?: string[];

  /**  */
  mediaFiles?: string[];

  /**  */
  programmingLanguage?: string;

  /**  */
  score?: number;

  /**  */
  avatarVideoUrl?: string;

  /**  */
  choices?: QuestionChoiceDto[];

  /**  */
  answer?: AnswerDto;

  /**  */
  analyzedInfo?: object;
}

export interface QuestionChoiceDto {
  /**  */
  title?: string;
}

export interface QuestionDetailItemDto {
  /**  */
  questionId?: string;

  /**  */
  questionText?: string;

  /**  */
  dimension?: string;

  /**  */
  averageScore?: number;

  /**  */
  responseCount?: number;

  /**  */
  supportersPercent?: number;

  /**  */
  passivesPercent?: number;

  /**  */
  detractorsPercent?: number;

  /**  */
  supportersCount?: number;

  /**  */
  passivesCount?: number;

  /**  */
  detractorsCount?: number;
}

export interface QuestionDto {
  /**  */
  id: string;

  /**  */
  rank?: number;

  /**  */
  question?: string;

  /**  */
  durationMin?: number;

  /**  */
  isCaseMode?: boolean;

  /**  */
  questionType?: QuestionType;

  /**  */
  skill?: string;

  /**  */
  settings?: QuestionDtoSettings;

  /**  */
  tags?: string[];

  /**  */
  images?: string[];

  /**  */
  mediaFiles?: string[];

  /**  */
  programmingLanguage?: string;

  /**  */
  score?: number;

  /**  */
  avatarVideoUrl?: string;

  /**  */
  choices?: QuestionChoiceDto[];
}

export interface QuestionDtoSettings {
  /**  */
  ignoreRating?: boolean;

  /**  */
  retryable?: boolean;

  /**  */
  thinkingTimeSeconds?: number;

  /**  */
  weight?: number;

  /**  */
  isAdminQuestion?: boolean;

  /**  */
  hasOtherValue?: boolean;
}

export interface QuestionPossibleAnswerQueueResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  answers?: InterviewImprovementSuggestion[];
}

export interface QuestionPossibleAnswerResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  answers?: InterviewImprovementSuggestion[];
}

export interface QuestionReportDto {
  /**  */
  questionId?: string;

  /**  */
  question?: string;

  /**  */
  questionType?: QuestionType;

  /**  */
  aiReportSummary?: string;

  /**  */
  count?: number;

  /**  */
  choiceStatistics?: ChoiceReportDto[];

  /**  */
  tagStatistics?: TagReportDto[];

  /**  */
  answerList?: string[];
}

export interface QuestionSettings {
  /**  */
  ignoreRating?: boolean;

  /**  */
  thinkingTimeSeconds?: number;

  /**  */
  weight?: number;

  /**  */
  retryable?: boolean;

  /**  */
  isAdminQuestion?: boolean;

  /**  */
  hasOtherValue?: boolean;
}

export interface QuestionSettingsContract {
  /**  */
  ignoreRating?: boolean;

  /**  */
  retryable?: boolean;

  /**  */
  thinkingTimeSeconds?: number;

  /**  */
  weight?: number;

  /**  */
  isAdminQuestion?: boolean;

  /**  */
  hasOtherValue?: boolean;
}

export interface RateCandidateRequest {
  /**  */
  rating?: number;
}

export interface ReInterviewRequest {
  /**  */
  questionIds?: string[];
}

export interface RefreshTokenRequest {
  /**  */
  refreshToken?: string;
}

export interface ReinviteSurveyRequest {
  /**  */
  participationIds?: string[];
}

export interface ReminderCandidateDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  interviewId?: string;

  /**  */
  rating?: number;

  /**  */
  aiRating?: number;
}

export interface ReminderGroupDto {
  /**  */
  remindDate?: string;

  /**  */
  emailTemplateId?: string;

  /**  */
  emailTemplateName?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  smsTemplateName?: string;

  /**  */
  phoneCallTemplateId?: string;

  /**  */
  phoneCallTemplateName?: string;

  /**  */
  candidates?: ReminderCandidateDto[];
}

export interface ReminderGroupDtoPagedResponseDto {
  /**  */
  data?: ReminderGroupDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface ResetPasswordRequest {
  /**  */
  email?: string;

  /**  */
  otp?: string;

  /**  */
  password?: string;
}

export interface RoleBasedTestFeedbackModelDto {
  /**  */
  review?: string;

  /**  */
  totalScore?: number;
}

export interface SectionDataModel {
  /**  */
  review?: string;

  /**  */
  point?: number;
}

export interface SectionPublicDataModel {
  /**  */
  id?: string;

  /**  */
  review?: string;

  /**  */
  point?: number;
}

export interface SelectedAnswerContract {
  /**  */
  title?: string;
}

export interface SelectedAnswerDto {
  /**  */
  isCorrect?: boolean;

  /**  */
  title?: string;
}

export interface ShareCandidatesRequest {
  /**  */
  fullName?: string;

  /**  */
  email?: string;

  /**  */
  body?: string;

  /**  */
  candidateIds?: string[];

  /**  */
  isHideUserInfo?: boolean;
}

export interface ShareIndexModel {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  sharingPersonId?: string;

  /**  */
  sharingPersonFullName?: string;

  /**  */
  sharingPersonEmail?: string;

  /**  */
  sharedPersonFullName?: string;

  /**  */
  sharedPersonEmail?: string;

  /**  */
  sharedCandidateId?: string;

  /**  */
  sharedCandidateEmail?: string;

  /**  */
  sharedCandidateFullName?: string;

  /**  */
  sharedInterviewTitle?: string;

  /**  */
  sharedInterviewId?: string;

  /**  */
  expirationDate?: string;

  /**  */
  isSystemUser?: boolean;
}

export interface ShareIndexModelPagedResponseDto {
  /**  */
  data?: ShareIndexModel[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface SharedInterviewDto {
  /**  */
  fullName?: string;

  /**  */
  email?: string;

  /**  */
  createdAt?: string;

  /**  */
  expireAt?: string;

  /**  */
  remainingDays?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  candidate?: CandidateBasicDto[];
}

export interface SharedInterviewDtoPagedResponseDto {
  /**  */
  data?: SharedInterviewDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface SkillRequest {
  /**  */
  skill?: string;
}

export interface SmsTemplateDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  culture?: string;

  /**  */
  createdAt?: string;

  /**  */
  isDefault?: boolean;

  /**  */
  type?: TemplateType;
}

export interface SmsTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  type?: TemplateType;
}

export interface SocialMediaRequest {
  /**  */
  linkedIn?: string;

  /**  */
  github?: string;
}

export interface SocialMediaResponse {
  /**  */
  linkedIn?: string;

  /**  */
  github?: string;
}

export interface SsoStartRequest {
  /**  */
  companySlug?: string;
}

export interface SsoStartRequestResponse {
  /**  */
  url?: string;
}

export interface SsoVerifyRequest {
  /**  */
  code?: string;

  /**  */
  state?: string;
}

export interface StartCvAnalysisRequest {
  /**  */
  name: string;

  /**  */
  surname: string;

  /**  */
  email: string;

  /**  */
  cvUrl: string;
}

export interface StartWaitingRequest {
  /**  */
  candidateId?: string;
}

export interface SuggestionResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  data?: CandidateDto;
}

export interface SummaryResponse {
  /**  */
  totalInterview?: number;

  /**  */
  totalCandidate?: number;

  /**  */
  totalCompletedInterview?: number;

  /**  */
  totalPendingInterview?: number;

  /**  */
  totalEvaluatedCount?: number;
}

export interface SupportAccountAnswerEdit {
  /**  */
  selectedAnswers?: SelectedAnswerContract[];

  /**  */
  openEndedAnswer?: string;

  /**  */
  otherAnswer?: string;

  /**  */
  score?: number;

  /**  */
  aiReview?: string;

  /**  */
  transcript?: string;

  /**  */
  mentionedTags?: string[];
}

export interface SurveyAdminQuestionChoiceDto {
  /**  */
  isCorrect?: boolean;

  /**  */
  title?: string;
}

export interface SurveyAdminQuestionDto {
  /**  */
  id?: string;

  /**  */
  question?: string;

  /**  */
  dimension?: string;

  /**  */
  questionType?: SurveyQuestionType;

  /**  */
  choices?: SurveyAdminQuestionChoiceDto[];

  /**  */
  settings?: SurveyQuestionSettingsDto;
}

export interface SurveyAiReviewGeneralDto {
  /**  */
  summary?: string;

  /**  */
  positive?: SurveyAiReviewItemDto;

  /**  */
  negative?: SurveyAiReviewItemDto;

  /**  */
  passive?: SurveyAiReviewItemDto;
}

export interface SurveyAiReviewItemDto {
  /**  */
  percentage?: number;

  /**  */
  notes?: string[];
}

export interface SurveyAiReviewQuestionReportDto {
  /**  */
  questionId?: string;

  /**  */
  summary?: string;

  /**  */
  positive?: SurveyAiReviewItemDto;

  /**  */
  negative?: SurveyAiReviewItemDto;

  /**  */
  passive?: SurveyAiReviewItemDto;
}

export interface SurveyAiReviewReportDto {
  /**  */
  general?: SurveyAiReviewGeneralDto;

  /**  */
  questionReports?: SurveyAiReviewQuestionReportDto[];
}

export interface SurveyAnswerDetailContract {
  /**  */
  selectedAnswers?: SurveySelectedAnswerContract[];

  /**  */
  answer?: string;
}

export interface SurveyAnswerQuestionsRequest {
  /**  */
  answers?: SurveyQuestionAnswerContract[];
}

export interface SurveyBasicDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  title?: string;

  /**  */
  description?: string;

  /**  */
  questionCount?: number;

  /**  */
  createdAt?: string;

  /**  */
  updatedAt?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  status?: SurveyStatus;

  /**  */
  createdBy?: string;
}

export interface SurveyBasicDtoPagedResponseDto {
  /**  */
  data?: SurveyBasicDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface SurveyDimensionsDto {
  /**  */
  dimensions?: string[];
}

export interface SurveyDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  title?: string;

  /**  */
  description?: string;

  /**  */
  questionCount?: number;

  /**  */
  createdAt?: string;

  /**  */
  updatedAt?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  status?: SurveyStatus;

  /**  */
  createdBy?: string;

  /**  */
  surveySettings?: SurveySettingsDto;
}

export interface SurveyHeatmapDto {
  /**  */
  dimensions?: string[];

  /**  */
  departments?: DepartmentScoreDto[];
}

export interface SurveyParticipationBasicDto {
  /**  */
  id?: string;

  /**  */
  surveyId?: string;

  /**  */
  department?: string;

  /**  */
  status?: SurveyParticipationStatus;

  /**  */
  createdAt?: string;

  /**  */
  completedAt?: string;

  /**  */
  rating?: number;

  /**  */
  aiRating?: number;
}

export interface SurveyParticipationBasicDtoPagedResponseDto {
  /**  */
  data?: SurveyParticipationBasicDto[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;

  /**  */
  totalPages?: number;
}

export interface SurveyParticipationExcelImportRequest {
  /**  */
  fileUrl?: string;
}

export interface SurveyParticipationQuestionResponse {
  /**  */
  questions?: SurveyQuestionDto[];
}

export interface SurveyQuestionAnswerContract {
  /**  */
  questionId?: string;

  /**  */
  answer?: SurveyAnswerDetailContract;

  /**  */
  isSkipped?: boolean;

  /**  */
  comment?: string;
}

export interface SurveyQuestionChoiceDto {
  /**  */
  title?: string;
}

export interface SurveyQuestionChoiceRequest {
  /**  */
  isCorrect?: boolean;

  /**  */
  title?: string;
}

export interface SurveyQuestionDto {
  /**  */
  id?: string;

  /**  */
  question?: string;

  /**  */
  dimension?: string;

  /**  */
  questionType?: SurveyQuestionType;

  /**  */
  choices?: SurveyQuestionChoiceDto[];

  /**  */
  settings?: SurveyQuestionSettingsDto;
}

export interface SurveyQuestionRequest {
  /**  */
  question?: string;

  /**  */
  dimension?: string;

  /**  */
  questionType?: SurveyQuestionType;

  /**  */
  choices?: SurveyQuestionChoiceRequest[];

  /**  */
  settings?: SurveyQuestionSettingsRequest;
}

export interface SurveyQuestionResponse {
  /**  */
  questions?: SurveyAdminQuestionDto[];

  /**  */
  isEditable?: boolean;
}

export interface SurveyQuestionSettingsDto {
  /**  */
  canSkip?: boolean;

  /**  */
  hasCommentField?: boolean;

  /**  */
  hasOtherValue?: boolean;
}

export interface SurveyQuestionSettingsRequest {
  /**  */
  canSkip?: boolean;

  /**  */
  hasCommentField?: boolean;

  /**  */
  hasOtherValue?: boolean;
}

export interface SurveyReportDto {
  /**  */
  nps?: NpsDto;

  /**  */
  commitment?: CommitmentDto;

  /**  */
  general?: GeneralDto;
}

export interface SurveyRequest {
  /**  */
  title?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  description?: string;

  /**  */
  questions?: SurveyQuestionRequest[];

  /**  */
  surveySettings?: SurveySettingsRequest;
}

export interface SurveyResponse {
  /**  */
  survey?: SurveyDto;

  /**  */
  participationCount?: number;

  /**  */
  completedParticipationCount?: number;

  /**  */
  nextSurveyId?: string;

  /**  */
  previousSurveyId?: string;
}

export interface SurveySelectedAnswerContract {
  /**  */
  title?: string;
}

export interface SurveySettingsDto {
  /**  */
  isShuffleEnabled?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;
}

export interface SurveySettingsRequest {
  /**  */
  isShuffleEnabled?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;
}

export interface TagReportDto {
  /**  */
  tag?: string;

  /**  */
  count?: number;

  /**  */
  percentage?: number;
}

export interface TemplateCreateInterviewRequest {
  /**  */
  companyId?: string;

  /**  */
  title?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;
}

export interface TemplateSettingsDto {
  /**  */
  isHideJoinInterviewButton?: boolean;
}

export interface TemplateTokenDto {
  /**  */
  key?: string;

  /**  */
  displayName?: string;

  /**  */
  templateTypes?: TemplateType[];
}

export interface TestRequest {
  /**  */
  to?: string;
}

export interface TrainingCandidateDetailResponse {
  /**  */
  trainingCandidateDto?: TrainingCandidateDto;

  /**  */
  products?: ProductDto[];

  /**  */
  isPaid?: boolean;

  /**  */
  isWaiting?: boolean;

  /**  */
  retryableQuestions?: number[];
}

export interface TrainingCandidateDto {
  /**  */
  id: string;

  /**  */
  interviewId: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  rating?: number;

  /**  */
  status?: InterviewStatus;

  /**  */
  createdAt?: string;

  /**  */
  aiRating?: number;

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  reAnalyzing?: boolean;

  /**  */
  categorizedQuestion?: CategorizedQuestionAnswerDto[];

  /**  */
  feedback?: string;

  /**  */
  completedAt?: string;

  /**  */
  certificateUrl?: string;

  /**  */
  shareLinks?: object;
}

export interface TrainingCandidateInterviewInfoResponse {
  /**  */
  interview?: InterviewBasicDto;

  /**  */
  products?: ProductDto[];

  /**  */
  isPaid?: boolean;
}

export interface TrainingCandidatePublicDto {
  /**  */
  createdAt?: string;

  /**  */
  successPosition?: number;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  categorizedQuestion?: CategorizedQuestionPublicAnswerDto[];

  /**  */
  interview?: InterviewBasicDto;

  /**  */
  certificateUrl?: string;

  /**  */
  shareLinks?: object;
}

export interface TrainingInterviewCreateQuestionsRequest {
  /**  */
  title?: string;

  /**  */
  jobDescription?: string;

  /**  */
  captchaToken?: string;
}

export interface TrainingInterviewCreateRequest {
  /**  */
  title?: string;

  /**  */
  jobDescription?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  captchaToken?: string;

  /**  */
  additionalData?: object;
}

export interface TrainingInterviewCreateWithQuestionRequest {
  /** Temperature in Degree Celesuis */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  questionId?: string;

  /**  */
  captchaToken?: string;
}

export interface TrainingInterviewCreationResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  data?: CreateTrainingInterviewResponse;
}

export interface TrainingInterviewQuestionsCreationResponse {
  /**  */
  isWaiting?: boolean;

  /**  */
  data?: TrainingQuestionsSummeryResponse;
}

export interface TrainingQuestionsSummeryResponse {
  /**  */
  questionCount?: number;

  /**  */
  totalDuration?: number;
}

export interface TrainingReminderRequest {
  /**  */
  mailTemplateId?: string;

  /**  */
  smsTemplateId?: string;

  /**  */
  whatsappTemplateId?: string;
}

export interface UpdateCategorizeInterviewCandidatesRequest {
  /**  */
  id: string;

  /**  */
  status?: InterviewStatus;

  /**  */
  count?: number;

  /**  */
  categorizedName: string;
}

export interface UpdateInterviewQuestionRequest {
  /**  */
  questions?: UpdateQuestionContract[];
}

export interface UpdateInterviewRequest {
  /**  */
  title?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  detail?: string;

  /**  */
  instructionVideoUrl?: string;
}

export interface UpdateInterviewSettings {
  /**  */
  interviewTitle: string;

  /**  */
  interviewType?: InterviewType;

  /**  */
  isShuffleEnabled?: boolean;

  /**  */
  isCamRecordingEnabled?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionAnalysisEnabled?: boolean;

  /**  */
  isSuggestionEnabled?: boolean;

  /**  */
  isAiAvatarEnabled?: boolean;

  /**  */
  isSecurityMeasuresEnabled?: boolean;
}

export interface UpdateInterviewStatusRequest {
  /**  */
  status?: Status;
}

export interface UpdateJobDescriptionRequest {
  /**  */
  jobDescription?: string;

  /**  */
  recalculate?: boolean;
}

export interface UpdateMailTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  templateSettings?: EmailTemplateSettingsUpdateRequest;
}

export interface UpdatePhoneCallTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;
}

export interface UpdateQuestionContract {
  /**  */
  id?: string;

  /**  */
  rank?: number;

  /**  */
  question?: string;

  /**  */
  durationMin?: number;

  /**  */
  isCaseMode?: boolean;

  /**  */
  questionType?: QuestionType;

  /**  */
  skill?: string;

  /**  */
  settings?: QuestionSettingsContract;

  /**  */
  tags?: string[];

  /**  */
  images?: string[];

  /**  */
  mediaFiles?: string[];

  /**  */
  programmingLanguage?: string;

  /**  */
  addedImageFileKeys?: string[];

  /**  */
  addedMediaFileKeys?: string[];

  /**  */
  choices?: AdminQuestionChoiceContract[];
}

export interface UpdateSmsTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;
}

export interface UpdateSurveyQuestionContract {
  /**  */
  id?: string;

  /**  */
  question?: string;

  /**  */
  dimension?: string;

  /**  */
  questionType?: SurveyQuestionType;

  /**  */
  choices?: SurveyQuestionChoiceRequest[];

  /**  */
  settings?: SurveyQuestionSettingsRequest;
}

export interface UpdateSurveyQuestionRequest {
  /**  */
  questions?: UpdateSurveyQuestionContract[];
}

export interface UpdateSurveyTitleRequest {
  /**  */
  title?: string;
}

export interface UpdateWhatsappTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;
}

export interface UploadFileRequest {
  /**  */
  contentType?: string;
}

export interface UploadFileResponse {
  /**  */
  signedUrl?: string;

  /**  */
  fileKey?: string;
}

export interface UploadUrlPostResponse {
  /**  */
  finalObjectUrl?: string;

  /**  */
  signedUrl?: string;

  /**  */
  requestHeaders?: object;
}

export interface UrlModel {
  /**  */
  panelUrl?: string;

  /**  */
  invitationUrl?: string;
}

export interface UsageLimitDto {
  /**  */
  interviewCandidateLimit?: number;

  /**  */
  smsLimit?: number;

  /**  */
  emailLimit?: number;

  /**  */
  callReminderLimit?: number;
}

export interface UsageLimitModel {
  /**  */
  interviewCandidateLimit?: number;

  /**  */
  smsLimit?: number;

  /**  */
  emailLimit?: number;

  /**  */
  callReminderLimit?: number;
}

export interface UsageRecordDto {
  /**  */
  emailSentCount?: number;

  /**  */
  smsSentCount?: number;

  /**  */
  callReminderCount?: number;

  /**  */
  interviewCandidateCount?: number;
}

export interface UsageRecordModel {
  /**  */
  emailSentCount?: number;

  /**  */
  smsSentCount?: number;

  /**  */
  callReminderCount?: number;

  /**  */
  interviewCandidateCount?: number;

  /**  */
  emailNotificationSent?: boolean;

  /**  */
  smsNotificationSent?: boolean;

  /**  */
  callReminderNotificationSent?: boolean;

  /**  */
  interviewCandidateNotificationSent?: boolean;
}

export interface UserBasicDto {
  /**  */
  id: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  createdAt?: string;

  /**  */
  updatedAt?: string;

  /**  */
  companyId?: string;

  /**  */
  identityNumber?: string;

  /**  */
  userType?: UserType;

  /**  */
  isSystemUser?: boolean;

  /**  */
  role?: RoleType;

  /**  */
  department?: DepartmentType;

  /**  */
  position?: UserPositionType;

  /**  */
  invitationStatus?: UserInvitationStatus;

  /**  */
  aiQuestionCreatedBefore?: boolean;
}

export interface UserDepartmentRequest {
  /**  */
  id?: string;

  /**  */
  department?: DepartmentType;
}

export interface UserDto {
  /**  */
  id: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  createdAt?: string;

  /**  */
  updatedAt?: string;

  /**  */
  companyId?: string;

  /**  */
  identityNumber?: string;

  /**  */
  userType?: UserType;

  /**  */
  isSystemUser?: boolean;

  /**  */
  role?: RoleType;

  /**  */
  department?: DepartmentType;

  /**  */
  position?: UserPositionType;

  /**  */
  invitationStatus?: UserInvitationStatus;

  /**  */
  aiQuestionCreatedBefore?: boolean;

  /**  */
  profileImage?: string;

  /**  */
  isSynapsAdmin?: boolean;

  /**  */
  isDemoCompany?: boolean;

  /**  */
  companyCreatedAt?: string;
}

export interface UserPositionRequest {
  /**  */
  id?: string;

  /**  */
  position?: UserPositionType;
}

export interface UserPutRequest {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  department?: DepartmentType;

  /**  */
  role?: RoleType;
}

export interface UserRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  department?: DepartmentType;

  /**  */
  role?: RoleType;
}

export interface UserRoleRequest {
  /**  */
  id?: string;

  /**  */
  role?: RoleType;
}

export interface UserUpdateRequest {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  email?: string;

  /**  */
  phone?: string;

  /**  */
  department?: DepartmentType;

  /**  */
  role?: RoleType;
}

export interface WaitingInterviewBasicDto {
  /**  */
  id: string;

  /**  */
  title?: string;

  /**  */
  detail?: string;

  /**  */
  questionCount?: number;

  /**  */
  status?: Status;

  /**  */
  createdBy?: string;

  /**  */
  createdAt?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  type?: InterviewType;

  /**  */
  isQuestionRetryable?: boolean;

  /**  */
  instructionVideoUrl?: string;

  /**  */
  informationalText?: string;

  /**  */
  isTrainingMode?: boolean;

  /**  */
  isShowGuideEnabled?: boolean;

  /**  */
  isEmotionDetectionEnabled?: boolean;

  /**  */
  jobDescription?: string;

  /**  */
  totalDuration?: number;

  /**  */
  invitationSetting?: InvitationSettingDto;

  /**  */
  interviewSettings?: InterviewSettingsDto;

  /**  */
  isTemplateInterview?: boolean;

  /**  */
  scheduleStatus?: InterviewScheduleStatus;

  /**  */
  candidateId?: string;
}

export interface WhatsappTemplateDto {
  /**  */
  id?: string;

  /**  */
  companyId?: string;

  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  culture?: string;

  /**  */
  createdAt?: string;

  /**  */
  isDefault?: boolean;

  /**  */
  type?: TemplateType;
}

export interface WhatsappTemplateRequest {
  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  type?: TemplateType;
}

export interface WorkExperienceInfo {
  /**  */
  position?: string;

  /**  */
  company?: string;

  /**  */
  industry?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  isStillWorking?: boolean;
}

export interface WorkExperienceRequest {
  /**  */
  position?: string;

  /**  */
  company?: string;

  /**  */
  industry?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  isStillWorking?: boolean;
}

export interface WorkExperienceResponse {
  /**  */
  position?: string;

  /**  */
  company?: string;

  /**  */
  industry?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  isStillWorking?: boolean;
}

export enum CandidateListType {
  'AllCandidates' = 'AllCandidates',
  'LongList' = 'LongList',
  'ShortList' = 'ShortList',
}

export enum CandidateSortColumn {
  'CreatedAt' = 'CreatedAt',
  'Rating' = 'Rating',
  'AiRating' = 'AiRating',
  'CvScore' = 'CvScore',
}

export enum CustomSortOrder {
  'Ascending' = 'Ascending',
  'Descending' = 'Descending',
}

export enum CvSection {
  'Summary' = 'Summary',
  'Education' = 'Education',
  'Experience' = 'Experience',
  'Skills' = 'Skills',
  'Languages' = 'Languages',
  'Certificates' = 'Certificates',
  'Personal' = 'Personal',
}

export enum DepartmentType {
  'Sales' = 'Sales',
  'Marketing' = 'Marketing',
  'HumanResources' = 'HumanResources',
  'InformationTechnologies' = 'InformationTechnologies',
  'Finance' = 'Finance',
  'ProductAndDesign' = 'ProductAndDesign',
  'OperationsAndCustomerSupport' = 'OperationsAndCustomerSupport',
  'Legal' = 'Legal',
  'RnD' = 'RnD',
  'Quality' = 'Quality',
  'Production' = 'Production',
  'ManagementOrStrategy' = 'ManagementOrStrategy',
  'Logistics' = 'Logistics',
}

export enum DiscountType {
  'Percentage' = 'Percentage',
  'Fixed' = 'Fixed',
}
export type HttpValidationProblemDetailsWithAdditionalProperties =
  HttpValidationProblemDetails & {
    [additionalProperties: string]: any | null;
  };
export enum IndustryType {
  'Technology' = 'Technology',
  'Software' = 'Software',
  'Healthcare' = 'Healthcare',
  'Finance' = 'Finance',
  'Education' = 'Education',
  'Manufacturing' = 'Manufacturing',
  'Retail' = 'Retail',
  'ConsultingServices' = 'ConsultingServices',
  'RealEstate' = 'RealEstate',
  'Transportation' = 'Transportation',
  'Entertainment' = 'Entertainment',
  'FoodBeverage' = 'FoodBeverage',
  'Energy' = 'Energy',
  'Telecommunications' = 'Telecommunications',
  'Automotive' = 'Automotive',
  'Agriculture' = 'Agriculture',
  'Construction' = 'Construction',
  'Legal' = 'Legal',
  'Insurance' = 'Insurance',
  'Media' = 'Media',
  'NonProfit' = 'NonProfit',
  'Government' = 'Government',
  'Hospitality' = 'Hospitality',
  'Pharmaceuticals' = 'Pharmaceuticals',
  'ECommerce' = 'ECommerce',
  'Other' = 'Other',
}

export enum InterviewScheduleStatus {
  'NotStarted' = 'NotStarted',
  'Expired' = 'Expired',
  'InProgress' = 'InProgress',
  'Cancelled' = 'Cancelled',
}

export enum InterviewStatus {
  'Added' = 'Added',
  'Invited' = 'Invited',
  'NotCompleted' = 'NotCompleted',
  'Completed' = 'Completed',
  'Evaluated' = 'Evaluated',
  'Positive' = 'Positive',
  'Negative' = 'Negative',
  'Pending' = 'Pending',
  'Hired' = 'Hired',
  'ActionRequired' = 'ActionRequired',
  'Paused' = 'Paused',
  'Deleted' = 'Deleted',
  'InternalProcess' = 'InternalProcess',
  'InternalProcessTwo' = 'InternalProcessTwo',
  'NotInterested' = 'NotInterested',
  'SentAgain' = 'SentAgain',
  'InTheInterview' = 'InTheInterview',
  'PreliminaryCompleted' = 'PreliminaryCompleted',
  'OfferSent' = 'OfferSent',
  'OfferRejected' = 'OfferRejected',
  'OfferAccepted' = 'OfferAccepted',
  'ReferenceCheck' = 'ReferenceCheck',
  'Withdrawn' = 'Withdrawn',
}

export enum InterviewType {
  'JobInterview' = 'JobInterview',
  'TechnicalInterview' = 'TechnicalInterview',
  'PersonalityInventory' = 'PersonalityInventory',
  'ExitInterview' = 'ExitInterview',
  'LanguageTest' = 'LanguageTest',
  'RoleBased' = 'RoleBased',
  'InterviewAssistant' = 'InterviewAssistant',
}

export enum PaymentProvider {
  'Apple' = 'Apple',
  'Google' = 'Google',
}
export type ProblemDetailsWithAdditionalProperties = ProblemDetails & {
  [additionalProperties: string]: any | null;
};
export enum ProductType {
  'Coaching' = 'Coaching',
  'CvAnalysis' = 'CvAnalysis',
}

export enum PromptType {
  'ExitInterviewPrompt' = 'ExitInterviewPrompt',
  'ExitInterviewQuizPrompt' = 'ExitInterviewQuizPrompt',
  'GeneralVideoPrompt' = 'GeneralVideoPrompt',
  'LanguageTestPrompt' = 'LanguageTestPrompt',
  'RoleBasedVideoPrompt' = 'RoleBasedVideoPrompt',
  'RoleBasedOverallPrompt' = 'RoleBasedOverallPrompt',
  'InterviewSuggestionPrompt' = 'InterviewSuggestionPrompt',
  'CodeAnalyzePrompt' = 'CodeAnalyzePrompt',
  'LanguageLevelPrompt' = 'LanguageLevelPrompt',
  'CreateCoachQuestionsPrompt' = 'CreateCoachQuestionsPrompt',
  'CoachAnalysisPrompt' = 'CoachAnalysisPrompt',
  'TrainingModePossibleAnswerPrompt' = 'TrainingModePossibleAnswerPrompt',
  'ReportQuestionSummaryPrompt' = 'ReportQuestionSummaryPrompt',
  'ChoiceReportQuestionSummaryPrompt' = 'ChoiceReportQuestionSummaryPrompt',
  'CvAnalysisPrompt' = 'CvAnalysisPrompt',
  'CvExtractionPrompt' = 'CvExtractionPrompt',
  'BoardCandidateCvAnalyzePrompt' = 'BoardCandidateCvAnalyzePrompt',
  'CVAnalysisPossibleAnswerOptionsPrompt' = 'CVAnalysisPossibleAnswerOptionsPrompt',
  'ExitInterviewVideoQuestionGenerationPrompt' = 'ExitInterviewVideoQuestionGenerationPrompt',
  'TechnicalInterviewVideoQuestionGenerationPrompt' = 'TechnicalInterviewVideoQuestionGenerationPrompt',
  'RoleBasedVideoQuestionGenerationPrompt' = 'RoleBasedVideoQuestionGenerationPrompt',
  'JobInterviewVideoQuestionGenerationPrompt' = 'JobInterviewVideoQuestionGenerationPrompt',
  'LanguageTestVideoQuestionGenerationPrompt' = 'LanguageTestVideoQuestionGenerationPrompt',
  'ExitInterviewQuizQuestionGenerationPrompt' = 'ExitInterviewQuizQuestionGenerationPrompt',
  'TechnicalInterviewQuizQuestionGenerationPrompt' = 'TechnicalInterviewQuizQuestionGenerationPrompt',
  'RoleBasedQuizQuestionGenerationPrompt' = 'RoleBasedQuizQuestionGenerationPrompt',
  'JobInterviewQuizQuestionGenerationPrompt' = 'JobInterviewQuizQuestionGenerationPrompt',
  'LanguageTestQuizQuestionGenerationPrompt' = 'LanguageTestQuizQuestionGenerationPrompt',
  'ExitInterviewCaseQuestionGenerationPrompt' = 'ExitInterviewCaseQuestionGenerationPrompt',
  'TechnicalInterviewCaseQuestionGenerationPrompt' = 'TechnicalInterviewCaseQuestionGenerationPrompt',
  'RoleBasedCaseQuestionGenerationPrompt' = 'RoleBasedCaseQuestionGenerationPrompt',
  'JobInterviewCaseQuestionGenerationPrompt' = 'JobInterviewCaseQuestionGenerationPrompt',
  'LanguageTestCaseQuestionGenerationPrompt' = 'LanguageTestCaseQuestionGenerationPrompt',
  'GenerateTagPrompt' = 'GenerateTagPrompt',
  'SurveyQuestionAnalyzePrompt' = 'SurveyQuestionAnalyzePrompt',
  'SurveyGeneralAnalyzePrompt' = 'SurveyGeneralAnalyzePrompt',
}

export enum QuestionGenerationType {
  'Video' = 'Video',
  'Quiz' = 'Quiz',
  'Case' = 'Case',
  'MultipleChoice' = 'MultipleChoice',
  'MultipleSelect' = 'MultipleSelect',
  'OpenEnded' = 'OpenEnded',
}

export enum QuestionType {
  'Video' = 'Video',
  'File' = 'File',
  'MultipleChoice' = 'MultipleChoice',
  'MultipleSelection' = 'MultipleSelection',
  'OpenEnded' = 'OpenEnded',
  'Code' = 'Code',
  'Score' = 'Score',
}

export enum RoleType {
  'Expert' = 'Expert',
  'Administrator' = 'Administrator',
  'SuperAdmin' = 'SuperAdmin',
}

export enum SendInvitationChannel {
  'Email' = 'Email',
  'Call' = 'Call',
  'Sms' = 'Sms',
  'Whatsapp' = 'Whatsapp',
}

export type SmtpEncryptionType = 0 | 1 | 2 | 3;

export enum Status {
  'Pending' = 'Pending',
  'Active' = 'Active',
  'Inactive' = 'Inactive',
  'Completed' = 'Completed',
  'Canceled' = 'Canceled',
  'Deleted' = 'Deleted',
}

export enum SurveyParticipationSortColumn {
  'CreatedAt' = 'CreatedAt',
  'Rating' = 'Rating',
  'AiScore' = 'AiScore',
  'CompletedAt' = 'CompletedAt',
}

export enum SurveyParticipationStatus {
  'Added' = 'Added',
  'Invited' = 'Invited',
  'NotCompleted' = 'NotCompleted',
  'Completed' = 'Completed',
}

export enum SurveyQuestionType {
  'MultipleChoice' = 'MultipleChoice',
  'MultipleSelection' = 'MultipleSelection',
  'OpenEnded' = 'OpenEnded',
  'Nps' = 'Nps',
  'LikertScale' = 'LikertScale',
}

export enum SurveyStatus {
  'Active' = 'Active',
  'Inactive' = 'Inactive',
}

export enum TemplateType {
  'Interview' = 'Interview',
  'Generic' = 'Generic',
}

export enum UserInvitationStatus {
  'Pending' = 'Pending',
  'Accepted' = 'Accepted',
  'Removed' = 'Removed',
}

export enum UserPositionType {
  'GeneralManager' = 'GeneralManager',
  'Product' = 'Product',
  'HRManager' = 'HRManager',
}

export enum UserType {
  'CompanyAdmin' = 'CompanyAdmin',
  'User' = 'User',
  'SharedInterview' = 'SharedInterview',
  'Candidate' = 'Candidate',
}
